import React, { Fragment, useState, useEffect, useCallback } from "react";
import { H5, H4, H6, Btn, P, H2 } from "../../AbstractElements";
import {
  Container,
  Row,
  Input,
  Table,
  CardHeader,
  CardFooter,
  Col,
  Card,
  InputGroup,
  CardBody,
  Form,
  Label,
} from "reactstrap";
import "rc-pagination/assets/index.css";
import "../../assets/scss/index.less";
import { Link, useNavigate, useParams } from "react-router-dom";
import Button from "react-bootstrap/Button";
import { useForm } from "react-hook-form";
import * as mutations from "../../graphql/mutations";
import * as queries from "../../graphql/queries";
import { toast } from "react-toastify";
import awsExports from "../../aws-exports";
import uuid from "react-native-uuid";
import moment from "moment";
import Pagination from "rc-pagination";
import cloneDeep from "lodash/cloneDeep";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import AWS from "aws-sdk";
import jsPDF from "jspdf";
import KYASPLogo from "../../assets/images/logo/KYASP logo.png";
import autoTable from "jspdf-autotable";
import {
  S3_BUCKET,
  REGION,
  ASSET_OWNER_FOLDER,
  SECRETACCESSKEY,
  ACCESSKEYID,
  USERPOOLID,
  limit,
} from "../../Config/Config";
import DatePicker from "react-datepicker";
import Select from "react-select";
import SiteData from "../../Data/Sites/index";
import { generateClient } from "aws-amplify/api";
import axios from "axios";
const client = generateClient({
  headers: {
    "x-api-key": "da2-ox6gomta4baghjuzk6hpogw25y",
  },
});

const GenerateLogBookReports = ({ data }) => {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    e,
    ...form
  } = useForm();
  const [sites, setSites] = useState([]);
  const [distributionBox, setDistributionBox] = useState([]);
  const [distributionBoxFilter, setDistributionBoxfilter] = useState([]);
  const [assets, setAssets] = useState([]);
  const [siteId, setSiteId] = useState("");
  const [loading, setLoading] = useState(false);
  const [siteDetail, setSiteDetail] = useState([]);
  const countPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [assetDemo, setAssetDemo] = useState([]);
  const LoginUserDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userPermission =
    LoginUserDetails.hasOwnProperty("permissions") &&
      LoginUserDetails.permissions !== null
      ? JSON.parse(LoginUserDetails.permissions)
      : [];
  const [mc, setMc] = useState([]);
  const [ao, setAo] = useState([]);
  const [fullSites, setFullSites] = useState(SiteData.getSiteData());
  const [company, setCompany] = useState([]);
  const [selectedImg, setselectedImg] = useState(null);
  const [downloadedFile, setdownloadedFile] = useState(null);
  const [assetDemoRR, setAssetDemoRR] = useState([]);
  const [assetRR, setAssetRR] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const LoginUserGroup = localStorage.getItem("groups");
  const [asset, setAsset] = useState([]);
  const [demofilter, setFilter] = useState([]);
  const [assetVal, setAssetVal] = useState("");
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [warrantyDate, setWarrantyDate] = useState(null);
  //const [limit, setLimit] = useState(100000);

  AWS.config.update({
    accessKeyId: ACCESSKEYID,
    secretAccessKey: SECRETACCESSKEY,
  });
  const myBucket = new AWS.S3({
    params: { Bucket: S3_BUCKET },
    region: REGION,
  });

  async function getCompanyByAssetId() {
    try {
      const result2 = await client
        .graphql({
          query: queries.getAssetOwner,
          variables: {
            id: LoginUserDetails.id,
            limit: limit,

            // filter: {
            //   id: {
            //     eq: LoginUserDetails.id,
            //   },
            // },
          },
          authMode: "API_KEY",
        });
      if (result2.data.getAssetOwner !== null) {
        console.log(result2);
        //if (result2.data.listAssetOwners.items.length > 0) {
        const result = await client
          .graphql({
            query: queries.getCompanyDetails,
            variables: {
              id: result2.data.getAssetOwner.companydetailsID,
              limit: limit,
              // filter: {
              //   id: {
              //     eq: result2.data.getAssetOwner.companydetailsID,
              //   },
              // },
            },
            authMode: "API_KEY",
          });
        if (result.data.getCompanyDetails !== null) {
          console.log(result);
          setCompany(result.data.getCompanyDetails);
        }
        //}
      }
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    console.log(data);
    // getSite(data.sites);
    getDistributionBox(data.distributionBox);
    console.log(data.sites);
    if (
      data.sites === "allSites" &&
      data.distributionBox === "allDistribution"
    ) {
      console.log("All site  and all distribution boards selected");
      console.log(LoginUserGroup);
      getCompanyByAssetId();
      if (LoginUserGroup === "site_user") {
        //fetchSiteDetailsSU();
        fetchRRSU();
      } else if (LoginUserGroup === "electrician") {
        //fetchSiteDetailsSU();
        fetchRRSU();
      } else {
        //fetchListLogBookDetails();
        //getAssetsRRDemo();
      }
      toast.success(
        `We will email the logbook report to the logged-in user's email address once it is generated.`,
        {
          position: toast.POSITION.TOP_CENTER,
        }
      );
      fetchListLogBookDetails();
    } else if (
      data.sites !== "allSites" &&
      data.distributionBox === "allDistribution"
    ) {
      console.log("single site  and all distribution boards selected");
      fetchListLogBookDetails1(data.sites, data.assetTemp, data.warranty);
      getAssetsRR(data.sites, data.assetTemp);
      getSite(data.sites);
    } else {
      getAssets(data.sites, data.distributionBox, data.assetTemp, data.warranty);
      getAssetsRRSingleDBSite(data.sites, data.distributionBox);
      getSite(data.sites);
    }
    //getAssets(data.sites, data.distributionBox);
    getUserdetails();
    //getAssetsRR(data.sites);
    //getAO();
    if (LoginUserGroup === "site_user") {
      fetchSUByAo();
    } else if (LoginUserGroup === "electrician") {
      fetchSUByAo();
    } else {
      getAO();
    }
    //fetchAssets(data.sites, data.distributionBox);
  }, []);

  async function fetchAssets(site, db) {
    console.log("Asset - sites", sites);
    if (data.sites !== "allSites") {
      await client
        .graphql({
          query: queries.listAssets,
          authMode: "API_KEY",
          variables: {
            limit: limit,
            filter: {
              siteId: {
                eq: site,
              },
            },
          },
        })
        .then((result) => {
          console.log(result);
          if (result.data.listAssets.items.length > 0) {
            let asset = result.data.listAssets.items.filter((item) => {
              const _matchingAssetTemplate = data.assetTemp?.find(
                (temp) => temp === item?.assettemplateID
              );
              if (_matchingAssetTemplate) {
                return item;
              }
            });
            let assetfilter = [];
            console.log(data.distributionBox);
            console.log(db);
            if (data.distributionBox === "allDistribution") {
              assetfilter = asset;
            } else {
              assetfilter = asset.filter(
                (item) => item.distributionboxID === db
              );
              console.log(assetfilter);
            }
            const sort = assetfilter.sort(
              (a, b) => a.fittingNumber - b.fittingNumber
            );
            console.log(sort);
            const assetOptions = [{ value: null, label: "All Assets" }];
            sort.map(async (item) => {
              assetOptions.push({
                value: item.id,
                label: item.fittingNumber,
              });
            });

            setAsset(assetOptions);
          } else {
            setAsset([]);
          }
        })
        .catch((error) => {
          console.log(error);
          setAsset([]);
        });
    } else {
      if (LoginUserGroup === "site_owner") {
        await client
          .graphql({
            query: queries.siteDetailsByAssetownerID,
            variables: {
              assetownerID: LoginUserDetails.id,
              limit: limit,
            },
            authMode: "API_KEY",
          })
          .then((sites) => {
            console.log("sites");
            console.log(sites);
            //setSites(sites.data.siteDetailsByAssetownerID.items);
            let siteIds = [];
            if (sites.data.siteDetailsByAssetownerID.items.length > 0) {
              sites.data.siteDetailsByAssetownerID.items.map((item) => {
                siteIds.push(item.id);
              });
              console.log(siteIds);
              const promises = sites.data.siteDetailsByAssetownerID.items.map(
                async (siteee) => {
                  return client.graphql({
                    query: queries.assetsBySitedetailsID,
                    variables: {
                      sitedetailsID: siteee.id,
                      limit: limit,
                    },
                  });
                }
              );
              Promise.all(promises)
                .then((results) => {
                  const testReport1 = [];
                  let assetFilter = [];
                  results.forEach((result1) => {
                    const assetList = result1.data.assetsBySitedetailsID.items;
                    //console.log(assetList);
                    if (assetList.length > 0) {
                      console.log(assetList);
                      let asset = assetList.filter((item) => {
                        const _matchingAssetTemplate = data.assetTemp?.find(
                          (temp) => temp === item?.assettemplateID
                        );
                        if (_matchingAssetTemplate) {
                          return item;
                        }
                      });
                      testReport1.push(...asset);
                    }
                  });
                  console.log("final data");
                  console.log(testReport1);
                  const sorted = testReport1.sort(
                    (a, b) => a.fittingNumber - b.fittingNumber
                  );
                  console.log(sorted);
                  const assetOptions = [{ value: null, label: "All Assets" }];
                  sorted.map(async (item) => {
                    assetOptions.push({
                      value: item.id,
                      label: item.fittingNumber,
                    });
                  });
                  setAsset(assetOptions);
                })
                .catch((error) => {
                  console.log(error);
                  setErrorMessage("Unable to fetch the list");
                });
            } else {
              //setIsLoading(false);
            }
          })
          .catch((error) => {
            console.log(error);
            //setIsLoading(false);
          });
      } else {
        await client
          .graphql({
            query: queries.linkUsersAndSitesByUserdetailsID,
            authMode: "API_KEY",
            variables: {
              userdetailsID: LoginUserDetails.id,
              filter: {
                status: {
                  eq: "Active",
                },
              },
              limit: limit,
            },
          })
          .then((dataDetails) => {
            const siteDetails =
              dataDetails.data.linkUsersAndSitesByUserdetailsID.items;
            if (siteDetails.length > 0) {
              client
                .graphql({
                  query: queries.listSiteDetails,
                  variables: {
                    limit: limit,
                  },
                })
                .then((result) => {
                  console.log(result);
                  const siteDetail = result.data.listSiteDetails.items.filter(
                    (item) => {
                      const _matchingAssetTemplate = siteDetails?.find(
                        (site) => site.sitedetailsID === item?.id
                      );
                      if (_matchingAssetTemplate) {
                        return item;
                      }
                    }
                  );
                  console.log(siteDetail);
                  let siteIds = [];
                  if (siteDetail.length > 0) {
                    siteDetail.map((item) => {
                      siteIds.push(item.id);
                    });
                    console.log(siteIds);
                    const promises = siteDetail.map(async (siteee) => {
                      return client.graphql({
                        query: queries.assetsBySitedetailsID,
                        variables: {
                          sitedetailsID: siteee.id,
                          filter: {
                            status: {
                              eq: "Active",
                            },
                          },
                          limit: limit,
                        },
                      });
                    });
                    Promise.all(promises)
                      .then((results) => {
                        const testReport1 = [];
                        let assetFilter = [];
                        results.forEach((result1) => {
                          const assetList =
                            result1.data.assetsBySitedetailsID.items;
                          console.log(assetList);
                          if (assetList.length > 0) {
                            console.log(assetList);
                            testReport1.push(...assetList);
                          }
                        });
                        console.log("final data");
                        console.log(testReport1);
                        const sort = testReport1.sort(
                          (a, b) => a.fittingNumber - b.fittingNumber
                        );
                        console.log(sort);
                        const assetOptions = [
                          { value: null, label: "All Assets" },
                        ];
                        sort.map(async (item) => {
                          assetOptions.push({
                            value: item.id,
                            label: item.fittingNumber,
                          });
                        });
                        setAsset(assetOptions);
                      })
                      .catch((error) => {
                        console.log(error);
                        setErrorMessage("Unable to fetch the list");
                      });
                  } else {
                    //setIsLoading(false);
                  }
                })
                .catch((error2) => {
                  console.log(error2);
                  //setIsLoading(false);
                });
            }
          })
          .catch((error) => {
            console.log(error);
            //setIsLoading(false);
          });
      }
    }
  }

  async function getSite(siteId) {
    try {
      if (data.sites !== "allSites") {
        const result = await client
          .graphql({
            query: queries.getSiteDetails,
            variables: {
              id: siteId,
              limit: limit,
              // filter: {
              //   id: {
              //     eq: siteId,
              //   },
              // },
            },
            authMode: "API_KEY",
          });
        if (result.data.getSiteDetails !== null) {
          console.log(result);
          setSites(result.data.getSiteDetails);
          const CompId = result.data.getSiteDetails.companydetailsID;
          console.log(CompId);
          const result2 = await client
            .graphql({
              query: queries.getCompanyDetails,
              variables: {
                id: CompId,
                limit: limit,
                // filter: {
                //   id: {
                //     eq: CompId,
                //   },
                // },
              },
              authMode: "API_KEY",
            });
          if (result2.data.getCompanyDetails !== null) {
            console.log(result2);
            setCompany(result2.data.getCompanyDetails);
          }
        }
      } else {
        await client
          .graphql({
            query: queries.siteDetailsByAssetownerID,
            variables: {
              limit: limit,
              assetownerID: LoginUserDetails.id,
            },
            authMode: "API_KEY",
          })
          .then((result) => {
            console.log(result);
            if (result.data.siteDetailsByAssetownerID.items.length > 0) {
              setSites(
                result.data.siteDetailsByAssetownerID.items.filter(
                  (item) => item.status === "Active"
                )
              );
              const sites = result.data.siteDetailsByAssetownerID.items.filter(
                (item) => item.status === "Active"
              );
              const compID = [];
              sites.map((item) => {
                compID.push(item.companydetailsID);
              });
              client
                .graphql({
                  query: queries.listCompanyDetails,
                  variables: {
                    limit: limit,
                    filter: {
                      id: {
                        status: "Active",
                      },
                    },
                  },
                  authMode: "API_KEY",
                })
                .then((result2) => {
                  console.log(result2);
                  if (result2.data.listCompanyDetails.items.length > 0) {
                    let company = result2.data.listCompanyDetails.items.filter(
                      (item) => {
                        const _matchingCompany = compID?.find(
                          (temp) => temp === item?.id
                        );
                        if (_matchingCompany) {
                          return item;
                        }
                      }
                    );
                    setCompany(company);
                  } else {
                    setCompany([]);
                  }
                })
                .catch((error) => {
                  console.log(error);
                });
            } else {
              setSites([]);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } catch (error) {
      console.error(error);
    }
  }

  async function getDistributionBox(dbId) {
    try {
      if (dbId != "allDistribution") {
        {
          /*
        await client.graphql({
          query: queries.getDistributionBox,
          authMode: "API_KEY",
          variables: {
            id: dbId,
            filter: {
              status: {
                eq: "Active",
              },
            },
            limit: limit,
          },
        })
          .then((result) => {
            console.log(result);
            console.log(result.data.getDistributionBox);
            setDistributionBox(result.data.getDistributionBox);
            setDistributionBoxfilter(result.data.getDistributionBox);
          })
          .catch((error) => {
            console.log(error);
          });
          */
        }
        //--
        let nextToken = "";
        let assets = [];
        await client
          .graphql({
            query: queries.listDistributionBoxes,
            authMode: "API_KEY",
            variables: {
              filter: {
                id: {
                  eq: dbId,
                },
                status: {
                  eq: "Active",
                },
              },
              limit: limit,
            },
          })
          .then(async (result) => {
            let assetDatas = result.data.listDistributionBoxes.items;
            nextToken = result.data.listDistributionBoxes.nextToken;
            if (result.data.listDistributionBoxes.items.length > 0) {
              assets.push(assetDatas);
            }
            while (nextToken !== null) {
              await client
                .graphql({
                  query: queries.listDistributionBoxes,
                  variables: {
                    filter: {
                      id: {
                        eq: dbId,
                      },
                      status: {
                        eq: "Active",
                      },
                    },
                    limit: limit,
                    nextToken: nextToken,
                  },
                  authMode: "API_KEY",
                })
                .then((results) => {
                  nextToken = results.data.listDistributionBoxes.nextToken;

                  if (results.data.listDistributionBoxes.items.length > 0) {
                    assets.push(results.data.listDistributionBoxes.items);
                  }
                })
                .catch((error) => {
                  console.log(error);
                });
            }
            console.log(assets);
            if (assets.length > 0) {
              const mergeAssets = assets.flat(1);
              console.log(mergeAssets);
              //--
              setDistributionBox(mergeAssets);
              setDistributionBoxfilter(mergeAssets);
            } else {
              setDistributionBox([]);
              setDistributionBoxfilter([]);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        //--
        let nextToken = "";
        let assets = [];
        await client
          .graphql({
            query: queries.listDistributionBoxes,
            authMode: "API_KEY",
            variables: {
              filter: {
                status: {
                  eq: "Active",
                },
              },
              limit: limit,
            },
          })
          .then(async (result) => {
            let assetDatas = result.data.listDistributionBoxes.items;
            nextToken = result.data.listDistributionBoxes.nextToken;
            if (result.data.listDistributionBoxes.items.length > 0) {
              assets.push(assetDatas);
            }
            while (nextToken !== null) {
              await client
                .graphql({
                  query: queries.listDistributionBoxes,
                  variables: {
                    filter: {
                      status: {
                        eq: "Active",
                      },
                    },
                    limit: limit,
                    nextToken: nextToken,
                  },
                  authMode: "API_KEY",
                })
                .then((results) => {
                  nextToken = results.data.listDistributionBoxes.nextToken;

                  if (results.data.listDistributionBoxes.items.length > 0) {
                    assets.push(results.data.listDistributionBoxes.items);
                  }
                })
                .catch((error) => {
                  console.log(error);
                });
            }
            console.log(assets);
            if (assets.length > 0) {
              const mergeAssets = assets.flat(1);
              console.log(mergeAssets);
              //--
              setDistributionBox(mergeAssets);
              setDistributionBoxfilter(mergeAssets);
            } else {
              setDistributionBox([]);
              setDistributionBoxfilter([]);
            }
          })
          .catch((error) => {
            console.log(error);
          });
        {
          /*
        await client.graphql({
          query: queries.listDistributionBoxes,
          authMode: "API_KEY",
          variables: {
            filter: {
              status: {
                eq: "Active",
              },
            },
            limit: 200000,
          },
        })
          .then((result) => {
            console.log(result);
            setDistributionBox(result.data.listDistributionBoxes.items);
            setDistributionBoxfilter(result.data.listDistributionBoxes.items);
          })
          .catch((error) => {
            console.log(error);
          });
        */
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  function getDB(id) {
    const db = distributionBox.find((item) => item.id === id);
    return db ? db.distributionBoxName : "";
  }

  React.useEffect(() => {
    if (siteId !== "") {
      setDistributionBoxfilter(
        distributionBox.filter((item) => {
          return item.sitedetailsID === siteId;
        })
      );
      setSiteDetail(
        sites.filter((item) => {
          return item.id === siteId;
        })
      );
    } else {
      setSiteDetail([]);
      setDistributionBoxfilter(distributionBox);
    }
  }, [siteId]);

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      console.log(data);
      getAssets(data.sites, data.distributionBox);

      const [newStartDate, newEndDate] = dateRange;
      // data.startDate = newStartDate;
      // data.endDate = newEndDate;
    } catch (e) {
      console.log(e);
    }
  };

  // maintenance  contractor
  async function getUserdetails() {
    try {
      const result = await client
        .graphql({
          query: queries.getUserDetails,
          variables: {
            id: LoginUserDetails.id,
            limit: limit,
            // filter: {
            //   id: {
            //     eq: LoginUserDetails.id,
            //   },
            // },
          },
          authMode: "API_KEY",
        })
      if (result.data.getUserDetails !== null) {
        let assetDatas = result.data.getUserDetails;
        //--
        setMc(result.data.getUserDetails);
      }
    } catch (error) {
      console.error(error);
    }
  }

  // ----Single Site And Single Db
  async function getAssets(siteId, distriButionBox, assettemp, warranty) {
    //---
    try {
      setLoading(true);
      let nextToken = "";
      let assets = [];
      let count = 0;
      for (let assetTempId of assettemp) {
        count = count + 1;
        let assetTempelateSiteId = assetTempId + "_" + siteId;
        const assetsData = await client.graphql({
          query: queries.assetsByAssettemplateSiteIDAndAssetNum,
          variables: {
            assettemplateSiteID: assetTempelateSiteId,
            filter: {
              distributionboxID: {
                eq: distriButionBox
              },
              status: {
                ne: "delete",
              },
            },
            limit: 1000,
          },
          authMode: "API_KEY",
        });
        console.log(assetsData);
        const data1 = assetsData.data.assetsByAssettemplateSiteIDAndAssetNum;
        nextToken = data1.nextToken;
        if (data1.items.length > 0) {
          assets.push(data1.items);
        }
        while (nextToken !== null) {
          const assetsData = await client.graphql({
            query: queries.assetsByAssettemplateSiteIDAndAssetNum,
            variables: {
              assettemplateSiteID: assetTempelateSiteId,
              limit: 1000,
              filter: {
                distributionboxID: {
                  eq: distriButionBox
                },
                status: {
                  ne: "delete",
                },
              },
              nextToken: nextToken,
            },
            authMode: "API_KEY",
          });
          console.log(assetsData);
          const data2 = assetsData.data.assetsByAssettemplateSiteIDAndAssetNum;
          nextToken = data2.nextToken;
          if (data2.items.length > 0) {
            assets.push(data2.items);
          }
        }
        console.log(assets);
        if (count === assettemp.length) {
          let assetFilter = [];
          let testReport = [];
          const mergeAssets = assets.flat(1);
          const assetOptions = [{ value: null, label: "All Assets" }];
          const sortt = mergeAssets.filter((item) => item.status === "Active");
          const sortoption = sortt.sort(
            (a, b) => a.fittingNumber - b.fittingNumber
          );
          sortoption.map(async (item) => {
            assetOptions.push({
              value: item.id,
              label: item.fittingNumber,
            });
          });
          setAsset(assetOptions);
          console.log(warranty);
          if (warranty !== "") {
            if (warranty === "InWarranty") {
              console.log("In Warranty");
              const today = new Date();
              assetFilter = mergeAssets.filter((item) => {
                const assetWarrantyEndDate = new Date(item.assetWarrantyEnd);
                return assetWarrantyEndDate > today;
              });
            } else {
              console.log("Out Warranty");
              const today = new Date();
              assetFilter = mergeAssets.filter((item) => {
                const assetWarrantyEndDate = new Date(item.assetWarrantyEnd);
                return assetWarrantyEndDate < today;
              });
            }
          } else {
            assetFilter = mergeAssets;
          }
          console.log(assetFilter);

          if (assetFilter.length > 0) {
            for (let [index, asset] of assetFilter.entries()) {
              let customFormatted = "-";

              if (asset.assetType !== "UPS Template") {
                const rawValue = asset.formFieldValues;
                console.log("Raw formFieldValues:", rawValue);

                try {
                  let valuesArray = [];

                  if (
                    rawValue &&
                    typeof rawValue === "object" &&
                    rawValue.wrapperName === "Set" &&
                    Array.isArray(rawValue.values)
                  ) {
                    valuesArray = rawValue.values;
                  }

                  else if (Array.isArray(rawValue)) {
                    valuesArray = rawValue;
                  }

                  if (valuesArray.length > 0) {
                    const first = valuesArray[0];
                    console.log(" Parsing value:", first);

                    const parsedArray = JSON.parse(first);

                    if (Array.isArray(parsedArray)) {
                      const lines = parsedArray
                        .filter(
                          (item) =>
                            item &&
                            typeof item === "object" &&
                            Object.keys(item).length > 0
                        )
                        .map((item) => {
                          const key = Object.keys(item)[0];
                          const value = item[key];
                          return `${key}: ${value}`;
                        });

                      if (lines.length > 0) {
                        customFormatted = lines.join("\n");
                      }
                    } else {
                      console.warn(" Parsed content is not an array");
                    }
                  } else {
                    console.warn(" valuesArray is empty");
                  }
                } catch (error) {
                  console.error("Error parsing formFieldValues:", error);
                }
              }

              const customFieldsFormatted = customFormatted;
              console.log(" Final customFieldsFormatted:", customFieldsFormatted);

              if (index < 3) {
                console.log(`Asset ${index + 1}: ${asset.fittingNumber}`);
                console.log("Custom Fields:\n", customFieldsFormatted);
              }

              testReport.push({
                id: asset.id,
                createdAt: asset.createdAt,
                asset: asset.fittingNumber,
                location: asset.assetLocation,
                distributionBox: asset.distributionboxID,
                customFields: customFieldsFormatted,
                status: asset.status,
                //logbookdate: item.logbookDateTime,
                warranty: asset.assetWarrantyEnd,
                //remarks: item.remarks,
              });
            }
            const sort = testReport.sort((a, b) => a.asset - b.asset);
            console.log("data.date", data.date);
            console.log(sort);
            if (data.date !== "" && data.date !== undefined) {
              if (data.date === "Custom") {
                const startDate = new Date(data.startDate);
                const endDate = new Date(data.endDate);

                // const filteredData = sort.filter((item) => {
                //   const createdAtDate = new Date(item.createdAt);
                //   return createdAtDate >= startDate && createdAtDate <= endDate;
                // });

                const filteredData = sort.filter((item) => {
                  const createdAtDate = moment(item.createdAt);

                  return (
                    createdAtDate.isSameOrAfter(moment(startDate, "DD/MM/YYYY"), "day") &&
                    createdAtDate.isSameOrBefore(moment(endDate, "DD/MM/YYYY"), "day")
                  );
                });

                console.log(filteredData);
                setAssetDemo(filteredData);
                setFilter(filteredData);
                setAssets(cloneDeep(filteredData.slice(0, countPerPage)));
              } else {
                const today = new Date();
                const thirtyDaysAgo = new Date();
                thirtyDaysAgo.setDate(today.getDate() - data.date);

                const filteredData = sort.filter((item) => {
                  const createdAtDate = new Date(item.createdAt);
                  return (
                    createdAtDate >= thirtyDaysAgo && createdAtDate <= today
                  );
                });
                console.log(filteredData);
                setAssetDemo(filteredData);
                setFilter(filteredData);
                setAssets(cloneDeep(filteredData.slice(0, countPerPage)));
              }
            } else {
              const today = new Date();
              const thirtyDaysAgo = new Date();
              thirtyDaysAgo.setDate(today.getDate() - 30);

              const filteredData = sort.filter((item) => {
                const createdAtDate = new Date(item.createdAt);
                return createdAtDate >= thirtyDaysAgo && createdAtDate <= today;
              });
              console.log("filteredData", filteredData);
              setAssetDemo(filteredData);
              setFilter(filteredData);
              setAssets(cloneDeep(filteredData.slice(0, countPerPage)));
            }
            setLoading(false);
          } else {
            console.log(testReport);
            setAssetDemo(testReport);
            setFilter(testReport);
            setAssets(cloneDeep(testReport.slice(0, countPerPage)));
            setLoading(false);
          }
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  // ----Single Site And All Distribution For Asset Owner ---
  async function fetchListLogBookDetails1(siteId, assettemp, warranty) {
    try {
      setLoading(true);
      let nextToken = "";
      let assets = [];
      let count = 0;
      for (let assetTempId of assettemp) {
        count = count + 1;
        let assetTempelateSiteId = assetTempId + "_" + siteId;
        const assetsData = await client.graphql({
          query: queries.assetsByAssettemplateSiteIDAndAssetNum,
          variables: {
            assettemplateSiteID: assetTempelateSiteId,
            filter: {
              status: {
                ne: "delete",
              },
            },
            limit: 1000,
          },
          authMode: "API_KEY",
        });
        console.log(assetsData);
        const data1 = assetsData.data.assetsByAssettemplateSiteIDAndAssetNum;
        nextToken = data1.nextToken;
        if (data1.items.length > 0) {
          assets.push(data1.items);
        }
        while (nextToken !== null) {
          const assetsData = await client.graphql({
            query: queries.assetsByAssettemplateSiteIDAndAssetNum,
            variables: {
              assettemplateSiteID: assetTempelateSiteId,
              limit: 1000,
              filter: {
                status: {
                  ne: "delete",
                },
              },
              nextToken: nextToken,
            },
            authMode: "API_KEY",
          });
          console.log(assetsData);
          const data2 = assetsData.data.assetsByAssettemplateSiteIDAndAssetNum;
          nextToken = data2.nextToken;
          if (data2.items.length > 0) {
            assets.push(data2.items);
          }
        }
        console.log(assets);
        if (count === assettemp.length) {
          let assetFilter = [];
          let testReport = [];
          const mergeAssets = assets.flat(1);
          const assetOptions = [{ value: null, label: "All Assets" }];
          const sortt = mergeAssets.filter((item) => item.status === "Active");
          const sortoption = sortt.sort(
            (a, b) => a.fittingNumber - b.fittingNumber
          );
          sortoption.map(async (item) => {
            assetOptions.push({
              value: item.id,
              label: item.fittingNumber,
            });
          });
          setAsset(assetOptions);
          console.log(warranty);
          if (warranty !== "") {
            if (warranty === "InWarranty") {
              console.log("In Warranty");
              const today = new Date();
              assetFilter = mergeAssets.filter((item) => {
                const assetWarrantyEndDate = new Date(item.assetWarrantyEnd);
                return assetWarrantyEndDate > today;
              });
            } else {
              console.log("Out Warranty");
              const today = new Date();
              assetFilter = mergeAssets.filter((item) => {
                const assetWarrantyEndDate = new Date(item.assetWarrantyEnd);
                return assetWarrantyEndDate < today;
              });
            }
          } else {
            assetFilter = mergeAssets;
          }
          console.log(assetFilter);

          if (assetFilter.length > 0) {
            for (let [index, asset] of assetFilter.entries()) {
              let customFormatted = "-";

              if (asset.assetType !== "UPS Template") {
                const rawValue = asset.formFieldValues;
                console.log("Raw formFieldValues:", rawValue);

                try {
                  let valuesArray = [];

                  if (
                    rawValue &&
                    typeof rawValue === "object" &&
                    rawValue.wrapperName === "Set" &&
                    Array.isArray(rawValue.values)
                  ) {
                    valuesArray = rawValue.values;
                  }

                  else if (Array.isArray(rawValue)) {
                    valuesArray = rawValue;
                  }

                  if (valuesArray.length > 0) {
                    const first = valuesArray[0];
                    console.log(" Parsing value:", first);

                    const parsedArray = JSON.parse(first);

                    if (Array.isArray(parsedArray)) {
                      const lines = parsedArray
                        .filter(
                          (item) =>
                            item &&
                            typeof item === "object" &&
                            Object.keys(item).length > 0
                        )
                        .map((item) => {
                          const key = Object.keys(item)[0];
                          const value = item[key];
                          return `${key}: ${value}`;
                        });

                      if (lines.length > 0) {
                        customFormatted = lines.join("\n");
                      }
                    } else {
                      console.warn(" Parsed content is not an array");
                    }
                  } else {
                    console.warn(" valuesArray is empty");
                  }
                } catch (error) {
                  console.error("Error parsing formFieldValues:", error);
                }
              }

              const customFieldsFormatted = customFormatted;
              console.log(" Final customFieldsFormatted:", customFieldsFormatted);

              if (index < 3) {
                console.log(`Asset ${index + 1}: ${asset.fittingNumber}`);
                console.log("Custom Fields:\n", customFieldsFormatted);
              }

              testReport.push({
                id: asset.id,
                createdAt: asset.createdAt,
                asset: asset.fittingNumber,
                location: asset.assetLocation,
                distributionBox: asset.distributionboxID,
                customFields: customFieldsFormatted,
                status: asset.status,
                //logbookdate: item.logbookDateTime,
                warranty: asset.assetWarrantyEnd,
                //remarks: item.remarks,
              });
            }
            const sort = testReport.sort((a, b) => a.asset - b.asset);
            console.log("data.date", data.date);
            console.log(sort);
            if (data.date !== "" && data.date !== undefined) {
              if (data.date === "Custom") {
                const startDate = new Date(data.startDate);
                const endDate = new Date(data.endDate);

                // const filteredData = sort.filter((item) => {
                //   const createdAtDate = new Date(item.createdAt);
                //   return createdAtDate >= startDate && createdAtDate <= endDate;
                // });

                const filteredData = sort.filter((item) => {
                  const createdAtDate = moment(item.createdAt);

                  return (
                    createdAtDate.isSameOrAfter(moment(startDate, "DD/MM/YYYY"), "day") &&
                    createdAtDate.isSameOrBefore(moment(endDate, "DD/MM/YYYY"), "day")
                  );
                });

                console.log(filteredData);
                setAssetDemo(filteredData);
                setFilter(filteredData);
                setAssets(cloneDeep(filteredData.slice(0, countPerPage)));
              } else {
                const today = new Date();
                const thirtyDaysAgo = new Date();
                thirtyDaysAgo.setDate(today.getDate() - data.date);

                const filteredData = sort.filter((item) => {
                  const createdAtDate = new Date(item.createdAt);
                  return (
                    createdAtDate >= thirtyDaysAgo && createdAtDate <= today
                  );
                });
                console.log(filteredData);
                setAssetDemo(filteredData);
                setFilter(filteredData);
                setAssets(cloneDeep(filteredData.slice(0, countPerPage)));
              }
            } else {
              const today = new Date();
              const thirtyDaysAgo = new Date();
              thirtyDaysAgo.setDate(today.getDate() - 30);

              const filteredData = sort.filter((item) => {
                const createdAtDate = new Date(item.createdAt);
                return createdAtDate >= thirtyDaysAgo && createdAtDate <= today;
              });
              console.log("filteredData", filteredData);
              setAssetDemo(filteredData);
              setFilter(filteredData);
              setAssets(cloneDeep(filteredData.slice(0, countPerPage)));
            }
            setLoading(false);
          } else {
            console.log(testReport);
            setAssetDemo(testReport);
            setFilter(testReport);
            setAssets(cloneDeep(testReport.slice(0, countPerPage)));
            setLoading(false);
          }
        }
      }
    } catch (error) {
      console.error(error);
      setAssetDemo([]);
      setAssets([]);
      setLoading(false);
    }
  }

  //---- All Sites  and All Distribution  for Asset Owner ----
  async function fetchListLogBookDetails() {
    console.log("All site ");
    //  let aoData;
    //     //const logoBase64 = await getBase64ImageFromUrl(KYASPLogo);
    //     //console.log(logoBase64);
    //      if (LoginUserGroup === "site_user" || LoginUserGroup === "electrician") {
    //   aoData = await fetchSUByAo();
    // } else {
    //   aoData = await getAO();
    // }

    // if (!aoData) {
    //   console.warn("AO data not found — skipping API call.");
    //   return;
    // }
    console.log(fullSites);
    const activesites = fullSites.filter(item => item.status === "Active");
    console.log(activesites);
    const logoBase64 = await getBase64ImageFromUrl(KYASPLogo);
    try {
      await axios.post(
        "https://klc4ghif39.execute-api.ap-southeast-2.amazonaws.com/default/logbookReportAllsites",
        {
          sites: fullSites,
          loggedInUser: LoginUserDetails.id,
          loggedInUsername: LoginUserDetails.username,
          dataa: data,
          email: LoginUserDetails.email,
          logoBase64: logoBase64,
          //ao: ao,
          //company: company,
          mc: mc,
          LoginUserGroup: LoginUserGroup
          //logoBase64: logoBase64,
          //imageBase64: downloadedFile,
        }
      );
    } catch (error) {
      console.log("error ", error);
    }
  }

  async function fetchListLogBookDetailstestallsites() {
    try {
      setLoading(true);
      //---
      let nextToken = "";
      let assets = [];
      await client
        .graphql({
          query: queries.siteDetailsByAssetownerID,
          variables: {
            assetownerID: LoginUserDetails.id,
            limit: limit,
          },
          authMode: "API_KEY",
        })
        .then(async (result) => {
          let assetDatas = result.data.siteDetailsByAssetownerID.items;
          nextToken = result.data.siteDetailsByAssetownerID.nextToken;
          if (result.data.siteDetailsByAssetownerID.items.length > 0) {
            assets.push(assetDatas);
          }
          while (nextToken !== null) {
            await client
              .graphql({
                query: queries.siteDetailsByAssetownerID,
                variables: {
                  assetownerID: LoginUserDetails.id,
                  limit: limit,
                  nextToken: nextToken,
                },
                authMode: "API_KEY",
              })
              .then((results) => {
                nextToken = results.data.siteDetailsByAssetownerID.nextToken;

                if (results.data.siteDetailsByAssetownerID.items.length > 0) {
                  assets.push(results.data.siteDetailsByAssetownerID.items);
                }
              })
              .catch((error) => {
                console.log(error);
              });
          }
          console.log(assets);
          if (assets.length > 0) {
            const mergeAssets = assets.flat(1);
            console.log(mergeAssets);
            //--
            if (mergeAssets.length > 0) {
              getAssetTemplate(mergeAssets);
            } else {
              //setSiteDetails([]);
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.error(error);
    }
  }

  //---
  const getAssetTemplate = async (siteData) => {
    try {
      await client
        .graphql({
          query: queries.assetTemplatesByCategoriesID,
          variables: {
            categoriesID: data.categoryId,
            filter: {
              status: {
                eq: "Active",
              },
            },
            limit: limit,
          },
          authMode: "API_KEY",
        })
        .then((result) => {
          console.log(result.data.assetTemplatesByCategoriesID.items);
          if (result.data.assetTemplatesByCategoriesID.items.length > 0) {
            getAssetsByTemplates(
              result.data.assetTemplatesByCategoriesID.items,
              siteData
            );
          }
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.error(error);
    }
  };

  async function getAssetsByTemplates(assetTemplates, siteData) {
    try {
      setLoading(true);
      let nextToken = "";
      let assets = [];
      let count = 0;
      const testReport = [];
      let counter = 0;
      assetTemplates.map((assetTemplate) => {
        count = count + 1;
        siteData.map(async (sites) => {
          let tempSiteId = assetTemplate.id + "_" + sites.id;
          await client
            .graphql({
              query: queries.assetsByAssettemplateSiteIDAndAssetNum,
              variables: {
                assettemplateSiteID: tempSiteId,
                limit: limit,
                filter: {
                  status: {
                    ne: "delete",
                  },
                },
              },
              authMode: "API_KEY",
            })
            .then(async (result) => {
              let assetDatas =
                result.data.assetsByAssettemplateSiteIDAndAssetNum.items;
              nextToken =
                result.data.assetsByAssettemplateSiteIDAndAssetNum.nextToken;
              if (
                result.data.assetsByAssettemplateSiteIDAndAssetNum.items
                  .length > 0
              ) {
                assets.push(assetDatas);
              }
              while (nextToken !== null) {
                await client
                  .graphql({
                    query: queries.assetsByAssettemplateSiteIDAndAssetNum,
                    variables: {
                      assettemplateSiteID: tempSiteId,
                      limit: limit,
                      filter: {
                        status: {
                          ne: "delete",
                        },
                      },
                      nextToken: nextToken,
                    },
                    authMode: "API_KEY",
                  })
                  .then((results) => {
                    nextToken =
                      results.data.assetsByAssettemplateSiteIDAndAssetNum
                        .nextToken;
                    if (
                      results.data.assetsByAssettemplateSiteIDAndAssetNum.items
                        .length > 0
                    ) {
                      assets.push(
                        results.data.assetsByAssettemplateSiteIDAndAssetNum
                          .items
                      );
                    }
                  })
                  .catch((error) => {
                    console.log(error);
                    setLoading(false);
                  });
              }
              console.log(assets);
            })
            .catch((error) => {
              console.log(error);
            });
          if (count === assetTemplates.length) {
            const mergeAssets = assets.flat(1);
            console.log(mergeAssets);

            //---
            let assetFilter = [];
            const assetOptions = [{ value: null, label: "All Assets" }];
            const sortt = mergeAssets.filter(
              (item) => item.status === "Active"
            );
            const sortoption = sortt.sort(
              (a, b) => a.fittingNumber - b.fittingNumber
            );
            sortoption.map(async (item) => {
              assetOptions.push({
                value: item.id,
                label: item.fittingNumber,
              });
            });
            setAsset(assetOptions);

            console.log(data.warranty);
            if (data.warranty !== "") {
              if (data.warranty === "InWarranty") {
                console.log("In Warranty");
                const today = new Date();
                assetFilter = mergeAssets.filter((item) => {
                  const assetWarrantyEndDate = new Date(item.assetWarrantyEnd);
                  return assetWarrantyEndDate > today;
                });
              } else {
                console.log("Out Warranty");
                const today = new Date();
                assetFilter = mergeAssets.filter((item) => {
                  const assetWarrantyEndDate = new Date(item.assetWarrantyEnd);
                  return assetWarrantyEndDate < today;
                });
              }
            } else {
              assetFilter = mergeAssets;
            }

            if (assetFilter.length > 0) {
              console.log(assetFilter);
              assetFilter.map((asset) => {
                counter = counter + 1;
                let customFormatted = [];
                if (asset.assetType === "UPS Template") {
                  console.log(" ups template ");
                  const custom = JSON.parse(asset.formFieldValues);
                  const numberOfKeys = Object.keys(custom).length;
                  customFormatted = "-";
                  console.log(customFormatted);
                } else {
                  if (
                    asset.formFieldValues === null ||
                    (Array.isArray(asset.formFieldValues) &&
                      asset.formFieldValues.length === 0)
                  ) {
                    customFormatted = "-";
                  } else {
                    try {
                      const custom = JSON.parse(asset.formFieldValues);
                      customFormatted =
                        custom &&
                        custom.map((item) => {
                          const key = Object.keys(item)[0];
                          const formattedValue = item[key];
                          return `${key} : ${formattedValue}`;
                        });
                      console.log(custom);
                    } catch (error) {
                      console.error("Error parsing JSON:", error);
                    }
                  }
                  console.log(customFormatted);
                }
                const customFieldsFormatted =
                  customFormatted === "-"
                    ? customFormatted
                    : customFormatted.join("\n");
                console.log(customFieldsFormatted);
                console.log("outside  date loop");
                testReport.push({
                  id: asset.id,
                  createdAt: asset.createdAt,
                  asset: asset.fittingNumber,
                  location: asset.assetLocation,
                  distributionBox: asset.distributionboxID,
                  customFields: customFieldsFormatted,
                  status: asset.status,
                  //logbookdate: item.logbookDateTime,
                  warranty: asset.assetWarrantyEnd,
                  //remarks: item.remarks,
                });
                if (counter === testReport.length) {
                  const sort = testReport.sort((a, b) => a.asset - b.asset);
                  console.log(sort);
                  const uniqueCombinedArray = Array.from(
                    new Map(sort.map((item) => [item.id, item])).values()
                  );
                  console.log(data.dateRange);
                  if (data.date !== "") {
                    if (data.date === "Custom") {
                      const startDate = new Date(data.startDate);
                      const endDate = new Date(data.endDate);

                      // const filteredData = uniqueCombinedArray.filter(
                      //   (item) => {
                      //     const createdAtDate = new Date(item.createdAt);
                      //     return (
                      //       createdAtDate >= startDate &&
                      //       createdAtDate <= endDate
                      //     );
                      //   }
                      // );

                      const filteredData = uniqueCombinedArray.filter((item) => {
                        const createdAtDate = moment(item.createdAt);

                        return (
                          createdAtDate.isSameOrAfter(moment(startDate, "DD/MM/YYYY"), "day") &&
                          createdAtDate.isSameOrBefore(moment(endDate, "DD/MM/YYYY"), "day")
                        );
                      });


                      console.log(filteredData);
                      setAssetDemo(filteredData);
                      setFilter(filteredData);
                      setAssets(cloneDeep(filteredData.slice(0, countPerPage)));
                    } else {
                      const today = new Date();
                      const thirtyDaysAgo = new Date();
                      thirtyDaysAgo.setDate(today.getDate() - data.date);

                      const filteredData = uniqueCombinedArray.filter(
                        (item) => {
                          const createdAtDate = new Date(item.createdAt);
                          return (
                            createdAtDate >= thirtyDaysAgo &&
                            createdAtDate <= today
                          );
                        }
                      );
                      console.log(filteredData);
                      setAssetDemo(filteredData);
                      setFilter(filteredData);
                      setAssets(cloneDeep(filteredData.slice(0, countPerPage)));
                    }
                  } else {
                    const today = new Date();
                    const thirtyDaysAgo = new Date();
                    thirtyDaysAgo.setDate(today.getDate() - 30);

                    const filteredData = uniqueCombinedArray.filter((item) => {
                      const createdAtDate = new Date(item.createdAt);
                      return (
                        createdAtDate >= thirtyDaysAgo && createdAtDate <= today
                      );
                    });
                    console.log(filteredData);
                    setAssetDemo(filteredData);
                    setFilter(filteredData);
                    setAssets(cloneDeep(filteredData.slice(0, countPerPage)));
                  }
                  setLoading(false);
                }
              });
            } else {
              setFilter(testReport);
              setAssetDemo(testReport);
              setAssets(cloneDeep(testReport.slice(0, countPerPage)));
              setLoading(false);
            }
          } else {
            if (counter === testReport.length) {
              const sort = testReport.sort(
                (a, b) => b.fittingNumber - a.fittingNumber
              );
              console.log(sort);
              setFilter(sort);
              setAssetDemo(sort);
              setAssets(cloneDeep(sort.slice(0, countPerPage)));
              setLoading(false);
            }
          }
        });
      });
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  }

  //---SU
  const getAssetTemplateSU = async (siteData) => {
    try {
      await client
        .graphql({
          query: queries.assetTemplatesByCategoriesID,
          variables: {
            categoriesID: data.categoryId,
            filter: {
              status: {
                eq: "Active",
              },
            },
            limit: limit,
          },
          authMode: "API_KEY",
        })
        .then((result) => {
          console.log(result.data.assetTemplatesByCategoriesID.items);
          if (result.data.assetTemplatesByCategoriesID.items.length > 0) {
            getAssetsByTemplatesSU(
              result.data.assetTemplatesByCategoriesID.items,
              siteData
            );
          }
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.error(error);
    }
  };

  async function getAssetsByTemplatesSU(assetTemplates, siteData) {
    try {
      setLoading(true);
      let nextToken = "";
      let assets = [];
      let count = 0;
      const testReport = [];
      let counter = 0;
      assetTemplates.map((assetTemplate) => {
        count = count + 1;
        siteData.map(async (sites) => {
          let tempSiteId = assetTemplate.id + "_" + sites.sitedetailsID;
          await client
            .graphql({
              query: queries.assetsByAssettemplateSiteIDAndAssetNum,
              variables: {
                assettemplateSiteID: tempSiteId,
                limit: limit,
                filter: {
                  status: {
                    ne: "delete",
                  },
                },
              },
              authMode: "API_KEY",
            })
            .then(async (result) => {
              let assetDatas =
                result.data.assetsByAssettemplateSiteIDAndAssetNum.items;
              nextToken =
                result.data.assetsByAssettemplateSiteIDAndAssetNum.nextToken;

              if (
                result.data.assetsByAssettemplateSiteIDAndAssetNum.items
                  .length > 0
              ) {
                assets.push(assetDatas);
              }
              while (nextToken !== null) {
                await client
                  .graphql({
                    query: queries.assetsByAssettemplateSiteIDAndAssetNum,
                    variables: {
                      assettemplateSiteID: tempSiteId,
                      limit: limit,
                      filter: {
                        status: {
                          ne: "delete",
                        },
                      },
                      nextToken: nextToken,
                    },
                    authMode: "API_KEY",
                  })
                  .then((results) => {
                    nextToken =
                      results.data.assetsByAssettemplateSiteIDAndAssetNum
                        .nextToken;

                    if (
                      results.data.assetsByAssettemplateSiteIDAndAssetNum.items
                        .length > 0
                    ) {
                      assets.push(
                        results.data.assetsByAssettemplateSiteIDAndAssetNum
                          .items
                      );
                    }
                  })
                  .catch((error) => {
                    console.log(error);
                    setLoading(false);
                  });
              }
              console.log(assets);
            })
            .catch((error) => {
              console.log(error);
            });
          if (count === assetTemplates.length) {
            const mergeAssets = assets.flat(1);
            console.log(mergeAssets);

            //---
            let assetFilter = [];
            const assetOptions = [{ value: null, label: "All Assets" }];
            const sortt = mergeAssets.filter(
              (item) => item.status === "Active"
            );
            const sortoption = sortt.sort(
              (a, b) => a.fittingNumber - b.fittingNumber
            );
            sortoption.map(async (item) => {
              assetOptions.push({
                value: item.id,
                label: item.fittingNumber,
              });
            });
            setAsset(assetOptions);

            console.log(data.warranty);
            if (data.warranty !== "") {
              if (data.warranty === "InWarranty") {
                console.log("In Warranty");
                const today = new Date();
                assetFilter = mergeAssets.filter((item) => {
                  const assetWarrantyEndDate = new Date(item.assetWarrantyEnd);
                  return assetWarrantyEndDate > today;
                });
              } else {
                console.log("Out Warranty");
                const today = new Date();
                assetFilter = mergeAssets.filter((item) => {
                  const assetWarrantyEndDate = new Date(item.assetWarrantyEnd);
                  return assetWarrantyEndDate < today;
                });
              }
            } else {
              assetFilter = mergeAssets;
            }

            if (assetFilter.length > 0) {
              console.log(assetFilter);

              assetFilter.map((asset) => {
                counter = counter + 1;
                let customFormatted = [];
                if (asset.assetType === "UPS Template") {
                  console.log(" ups template ");
                  const custom = JSON.parse(asset.formFieldValues);
                  const numberOfKeys = Object.keys(custom).length;
                  customFormatted = "-";
                  console.log(customFormatted);
                } else {
                  if (
                    asset.formFieldValues === null ||
                    (Array.isArray(asset.formFieldValues) &&
                      asset.formFieldValues.length === 0)
                  ) {
                    customFormatted = "-";
                  } else {
                    try {
                      const custom = JSON.parse(asset.formFieldValues);
                      customFormatted =
                        custom &&
                        custom.map((item) => {
                          const key = Object.keys(item)[0];
                          const formattedValue = item[key];
                          return `${key} : ${formattedValue}`;
                        });
                      console.log(custom);
                    } catch (error) {
                      console.error("Error parsing JSON:", error);
                    }
                  }
                  console.log(customFormatted);
                }
                const customFieldsFormatted =
                  customFormatted === "-"
                    ? customFormatted
                    : customFormatted.join("\n");
                console.log(customFieldsFormatted);

                console.log("outside  date loop");
                testReport.push({
                  id: asset.id,
                  createdAt: asset.createdAt,
                  asset: asset.fittingNumber,
                  location: asset.assetLocation,
                  distributionBox: asset.distributionboxID,
                  customFields: customFieldsFormatted,
                  status: asset.status,
                  //logbookdate: item.logbookDateTime,
                  warranty: asset.assetWarrantyEnd,
                  //remarks: item.remarks,
                });
                if (counter === testReport.length) {
                  const sort = testReport.sort((a, b) => a.asset - b.asset);
                  // const data = sort.sort((a, b) => {
                  //   const extractDigits = (assetNumber) =>
                  //     parseInt(assetNumber.match(/\d+/)[0]);
                  //   const assetNumberA = extractDigits(a.asset);
                  //   const assetNumberB = extractDigits(b.asset);
                  //   return assetNumberB - assetNumberA;
                  // });
                  console.log(sort);
                  const uniqueCombinedArray = Array.from(
                    new Map(sort.map((item) => [item.id, item])).values()
                  );
                  {
                    /*
                  setFilter(uniqueCombinedArray);
                  setAssetDemo(uniqueCombinedArray);
                  setAssets(cloneDeep(uniqueCombinedArray.slice(0, countPerPage)));
                  */
                  }
                  console.log(data.dateRange);
                  if (data.date !== "") {
                    if (data.date === "Custom") {
                      const startDate = new Date(data.startDate);
                      const endDate = new Date(data.endDate);

                      // const filteredData = uniqueCombinedArray.filter(
                      //   (item) => {
                      //     const createdAtDate = new Date(item.createdAt);
                      //     return (
                      //       createdAtDate >= startDate &&
                      //       createdAtDate <= endDate
                      //     );
                      //   }
                      // );

                      const filteredData = uniqueCombinedArray.filter((item) => {
                        const createdAtDate = moment(item.createdAt);

                        return (
                          createdAtDate.isSameOrAfter(moment(startDate, "DD/MM/YYYY"), "day") &&
                          createdAtDate.isSameOrBefore(moment(endDate, "DD/MM/YYYY"), "day")
                        );
                      });
                      console.log(filteredData);
                      setAssetDemo(filteredData);
                      setFilter(filteredData);
                      setAssets(cloneDeep(filteredData.slice(0, countPerPage)));
                    } else {
                      const today = new Date();
                      const thirtyDaysAgo = new Date();
                      thirtyDaysAgo.setDate(today.getDate() - data.date);

                      const filteredData = uniqueCombinedArray.filter(
                        (item) => {
                          const createdAtDate = new Date(item.createdAt);
                          return (
                            createdAtDate >= thirtyDaysAgo &&
                            createdAtDate <= today
                          );
                        }
                      );
                      console.log(filteredData);
                      setAssetDemo(filteredData);
                      setFilter(filteredData);
                      setAssets(cloneDeep(filteredData.slice(0, countPerPage)));
                    }
                  } else {
                    const today = new Date();
                    const thirtyDaysAgo = new Date();
                    thirtyDaysAgo.setDate(today.getDate() - 30);

                    const filteredData = uniqueCombinedArray.filter((item) => {
                      const createdAtDate = new Date(item.createdAt);
                      return (
                        createdAtDate >= thirtyDaysAgo && createdAtDate <= today
                      );
                    });
                    console.log(filteredData);
                    setAssetDemo(filteredData);
                    setFilter(filteredData);
                    setAssets(cloneDeep(filteredData.slice(0, countPerPage)));
                  }
                  setLoading(false);
                }
              });
            } else {
              setFilter(testReport);
              setAssetDemo(testReport);
              setAssets(cloneDeep(testReport.slice(0, countPerPage)));
              setLoading(false);
            }
          } else {
            if (counter === testReport.length) {
              const sort = testReport.sort(
                (a, b) => b.fittingNumber - a.fittingNumber
              );
              // const data = sort.sort((a, b) => {
              //   const extractDigits = (assetNumber) =>
              //     parseInt(assetNumber.match(/\d+/)[0]);
              //   const assetNumberA = extractDigits(a.asset);
              //   const assetNumberB = extractDigits(b.asset);
              //   return assetNumberB - assetNumberA;
              // });
              console.log(sort);
              setFilter(sort);
              setAssetDemo(sort);
              setAssets(cloneDeep(sort.slice(0, countPerPage)));
              setLoading(false);
            }
          }
        });
      });
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  }

  //-------- All Sites and All Distribution For Site User -----
  async function fetchSiteDetailsSU() {
    ///--
    try {
      setLoading(true);
      let nextToken = "";
      let assets = [];
      await client
        .graphql({
          query: queries.linkUsersAndSitesByUserdetailsID,
          authMode: "API_KEY",
          variables: {
            userdetailsID: LoginUserDetails.id,
            filter: {
              status: {
                eq: "Active",
              },
            },
            limit: limit,
          },
        })
        .then(async (result) => {
          let assetDatas = result.data.linkUsersAndSitesByUserdetailsID.items;
          nextToken = result.data.linkUsersAndSitesByUserdetailsID.nextToken;

          if (result.data.linkUsersAndSitesByUserdetailsID.items.length > 0) {
            assets.push(assetDatas);
          }
          while (nextToken !== null) {
            await client
              .graphql({
                query: queries.linkUsersAndSitesByUserdetailsID,
                authMode: "API_KEY",
                variables: {
                  userdetailsID: LoginUserDetails.id,
                  filter: {
                    status: {
                      eq: "Active",
                    },
                  },
                  limit: limit,
                  nextToken: nextToken,
                },
              })
              .then((results) => {
                nextToken =
                  results.data.linkUsersAndSitesByUserdetailsID.nextToken;

                if (
                  results.data.linkUsersAndSitesByUserdetailsID.items.length > 0
                ) {
                  assets.push(
                    results.data.linkUsersAndSitesByUserdetailsID.items
                  );
                }
              })
              .catch((error) => {
                console.log(error);
              });
          }
          console.log(assets);
          if (assets.length > 0) {
            const mergeAssets = assets.flat(1);
            console.log(mergeAssets);
            //--
            getAssetTemplateSU(mergeAssets);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.error(error);
    }
  }

  // Repair/Replace table for single site and all distribution
  async function getAssetsRR(siteId, assettemp) {
    //---
    try {
      let nextToken = "";
      let assets = [];
      let count = 0;
      for (let assetTempId of assettemp) {
        count = count + 1;
        let assetTempelateSiteId = assetTempId + "_" + siteId;
        const assetsData = await client.graphql({
          query: queries.repairsByAssettemplateSiteID,
          variables: {
            assettemplateSiteID: assetTempelateSiteId,
            limit: 1000,
          },
          authMode: "API_KEY",
        });
        console.log(assetsData);
        const data = assetsData.data.repairsByAssettemplateSiteID;
        nextToken = data.nextToken;
        if (data.items.length > 0) {
          assets.push(data.items);
        }
        while (nextToken !== null) {
          const assetsData = await client.graphql({
            query: queries.repairsByAssettemplateSiteID,
            variables: {
              assettemplateSiteID: assetTempelateSiteId,
              limit: 1000,
              nextToken: nextToken,
            },
            authMode: "API_KEY",
          });
          console.log(assetsData);
          const data = assetsData.data.repairsByAssettemplateSiteID;
          nextToken = data.nextToken;
          if (data.items.length > 0) {
            assets.push(data.items);
          }
        }
        if (count === assettemp.length) {
          let testReport = [];
          const mergeAssets = assets.flat(1);
          console.log(mergeAssets);
          console.log(mergeAssets);
          if (mergeAssets.length > 0) {
            // remove duplicates first
            const uniqueAssets = [
              ...new Map(mergeAssets.map((item) => [item.assetsID, item])).values(),
            ];

            const BATCH_SIZE = 10;

            (async () => {
              try {
                for (let i = 0; i < uniqueAssets.length; i += BATCH_SIZE) {
                  const batch = uniqueAssets.slice(i, i + BATCH_SIZE);

                  const batchPromises = batch.map((item) =>
                    client.graphql({
                      query: queries.getAssets,
                      variables: {
                        id: item.assetsID,
                        filter: {
                          status: {
                            ne: "delete",
                          },
                        },
                      },
                      authMode: "API_KEY",
                    })
                  );

                  const results = await Promise.all(batchPromises);

                  results.forEach((item) => {
                    if (item?.data?.getAssets) {
                      assets.push(item.data.getAssets);
                    }
                  });
                }

                console.log(assets);

                if (assets.length > 0 && mergeAssets?.length > 0) {
                  const testReport = [];

                  mergeAssets.forEach((repair) => {
                    const item = assets.find(
                      (asset) => asset.id === repair.assetsID
                    );

                    const custom = repair.customFields
                      ? JSON.parse(repair.customFields)
                      : [];

                    const customFieldsFormatted = custom
                      .map((obj) => {
                        const key = Object.keys(obj)[0];
                        return `${key} : ${obj[key]}`;
                      })
                      .join("\n");

                    testReport.push({
                      id: repair.id,
                      asset: item?.fittingNumber || "",
                      assetsID: item?.id || "",
                      RepairDate: repair.repairDate,
                      RepairTime: repair.repairTime,
                      replaced: repair.details,
                      location: item?.assetLocation || "",
                      distributionBox: item?.distributionboxID || "",
                      customFields: customFieldsFormatted,
                      logbookdate: repair.logbookDateTime,
                      warranty: repair.warrantyUpto,
                      remarks: repair.remarks,
                      additionalInfo: repair.additionalInformation,
                    });
                  });

                  setAssetDemoRR(testReport);
                  setAssetRR(testReport);
                  console.log(testReport);
                }


              } catch (error) {
                console.error(error);
                setLoading(false);
              }
            })();


          }
          // if (mergeAssets.length > 0) {
          //   let nextToken1 = "";
          //   mergeAssets.map(async (item) => {
          //     let assets1 = [];
          //     await client
          //       .graphql({
          //         query: queries.repairsByAssetsID,
          //         variables: {
          //           limit: limit,
          //           assetsID: item.id,
          //         },
          //         authMode: "API_KEY",
          //       })
          //       .then(async (result) => {
          //         let assetDatas = result.data.repairsByAssetsID.items;
          //         nextToken1 = result.data.repairsByAssetsID.nextToken;
          //         if (result.data.repairsByAssetsID.items.length > 0) {
          //           assets1.push(assetDatas);
          //         }
          //         while (nextToken1 !== null) {
          //           await client
          //             .graphql({
          //               query: queries.repairsByAssetsID,
          //               variables: {
          //                 limit: limit,
          //                 assetsID: item.id,
          //                 nextToken: nextToken1,
          //               },
          //               authMode: "API_KEY",
          //             })
          //             .then((results) => {
          //               nextToken1 = results.data.repairsByAssetsID.nextToken;
          //               if (results.data.repairsByAssetsID.items.length > 0) {
          //                 assets1.push(results.data.repairsByAssetsID.items);
          //               }
          //             })
          //             .catch((error) => {
          //               console.log(error);
          //             });
          //         }
          //         console.log(assets1);
          //         if (assets1.length > 0) {
          //           const mergeAssets1 = assets1.flat(1);
          //           console.log(mergeAssets1);
          //           //-

          //           const testing = mergeAssets1;
          //           console.log(testing);
          //           if (testing.length > 0) {
          //             testing.map((asset) => {
          //               testReport.push({
          //                 id: asset.id,
          //                 asset: item.fittingNumber,
          //                 assetsID: item.id,
          //                 RepairDate: asset.repairDate,
          //                 RepairTime: asset.repairTime,
          //                 replaced: asset.details,
          //                 location: item.assetLocation,
          //                 distributionBox: item.distributionboxID,
          //                 customFields: asset.customFields,
          //                 logbookdate: asset.logbookDateTime,
          //                 warranty: asset.warrantyUpto,
          //                 remarks: asset.remarks,
          //                 additionalInfo: asset.additionalInformation,
          //               });
          //             });
          //             setAssetDemoRR(testReport);
          //             setAssetRR(testReport);
          //             console.log(testReport);
          //           }
          //         }
          //       })
          //       .catch((error) => {
          //         console.log(error);
          //       });
          //   });
          // }
        }
      }
      {
        /*    await client.graphql({
        query: queries.assetsBySitedetailsID,
        variables: {
          sitedetailsID: siteId,
          limit: limit,
          filter: {
            status: {
              ne: "delete",
            },
          },
        },
        authMode: "API_KEY",
      })
        .then(async (result) => {
          let assetDatas = result.data.assetsBySitedetailsID.items;
          nextToken = result.data.assetsBySitedetailsID.nextToken;
          console.log(
            "first token count",
            result.data.assetsBySitedetailsID.items.length
          );
          console.log("nextToken 1", nextToken);
          if (result.data.assetsBySitedetailsID.items.length > 0) {
            assets.push(assetDatas);
          }
          while (nextToken !== null) {
            await client.graphql({
              query: queries.assetsBySitedetailsID,
              variables: {
                sitedetailsID: siteId,
                limit: limit,
                filter: {
                  status: {
                    ne: "delete",
                  },
                },
                nextToken: nextToken,
              },
              authMode: "API_KEY",
            })
              .then((results) => {
                nextToken = results.data.assetsBySitedetailsID.nextToken;
                console.log("nextToken", nextToken);
                console.log(results.data.assetsBySitedetailsID.items.length);
                if (results.data.assetsBySitedetailsID.items.length > 0) {
                  assets.push(results.data.assetsBySitedetailsID.items);
                }
              })
              .catch((error) => {
                console.log(error);
              });
          }
          console.log(assets);
          if (assets.length > 0) {
            const mergeAssets = assets.flat(1);
            console.log(mergeAssets);
            //--
            const asset = mergeAssets;
            let testReport1 = asset.filter((it) => {
              const _matchingAssetTemplate = data.assetTemp?.find(
                (temp) => temp === it?.assettemplateID
              );
              if (_matchingAssetTemplate) {
                return it;
              }
            });
            console.log(testReport1);
            const testReport = [];
            if (testReport1.length > 0) {
              let nextToken1 = "";
              testReport1.map(async (item) => {
                let assets1 = [];
                await client.graphql({
                  query: queries.listRepairs,
                  variables: {
                    limit: limit,
                    filter: {
                      assetsID: {
                        eq: item.id,
                      },
                    },
                  },
                  authMode: "API_KEY",
                })
                  .then(async (result) => {
                    let assetDatas = result.data.listRepairs.items;
                    nextToken1 = result.data.listRepairs.nextToken;
                    console.log(
                      "first token count",
                      result.data.listRepairs.items.length
                    );
                    console.log("nextToken 1", nextToken1);
                    if (result.data.listRepairs.items.length > 0) {
                      assets1.push(assetDatas);
                    }
                    while (nextToken1 !== null) {
                      await client.graphql({
                        query: queries.listRepairs,
                        variables: {
                          limit: limit,
                          filter: {
                            assetsID: {
                              eq: item.id,
                            },
                          },
                          nextToken: nextToken1,
                        },
                        authMode: "API_KEY",
                      })
                        .then((results) => {
                          nextToken1 = results.data.listRepairs.nextToken;
                          console.log("nextToken", nextToken1);
                          console.log(results.data.listRepairs.items.length);
                          if (results.data.listRepairs.items.length > 0) {
                            assets1.push(results.data.listRepairs.items);
                          }
                        })
                        .catch((error) => {
                          console.log(error);
                        });
                    }
                    console.log(assets1);
                    if (assets1.length > 0) {
                      const mergeAssets1 = assets1.flat(1);
                      console.log(mergeAssets1);
                      //-
  
                      const testing = mergeAssets1;
                      console.log(testing);
                      if (testing.length > 0) {
                        testing.map((asset) => {
                          testReport.push({
                            id: asset.id,
                            asset: item.fittingNumber,
                            assetsID: item.id,
                            RepairDate: asset.repairDate,
                            RepairTime: asset.repairTime,
                            replaced: asset.details,
                            location: item.assetLocation,
                            distributionBox: item.distributionboxID,
                            customFields: asset.customFields,
                            logbookdate: asset.logbookDateTime,
                            warranty: asset.warrantyUpto,
                            remarks: asset.remarks,
                            additionalInfo: asset.additionalInformation,
                          });
                        });
                        setAssetDemoRR(testReport);
                        setAssetRR(testReport);
                        console.log(testReport);
                      }
                    }
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              });
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
     
      await client.graphql({
        query: queries.assetsBySitedetailsID,
        variables: {
          sitedetailsID: siteId,
          limit: 20000,
        },
        authMode: "API_KEY",
      })
        .then((result) => {
          console.log(result);
          const asset = result.data.assetsBySitedetailsID.items;
          let testReport1 = asset.filter((it) => {
            const _matchingAssetTemplate = data.assetTemp?.find(
              (temp) => temp === it?.assettemplateID
            );
            if (_matchingAssetTemplate) {
              return it;
            }
          });
          console.log(testReport1)
          const testReport = [];
          if (testReport1.length > 0) {
            testReport1.map((item) => {
              client.graphql({
                query: queries.listRepairs,
                variables: {
                  limit: 20000,
                  filter: {
                    assetsID: {
                      eq: item.id,
                    },
                  },
                },
              })
                .then((testData) => {
                  const testing = testData.data.listRepairs.items;
                  console.log(testing);
                  if (testing.length > 0) {
                    testing.map((asset) => {
                      testReport.push({
                        id: asset.id,
                        asset: item.fittingNumber,
                        assetsID: item.id,
                        RepairDate: asset.repairDate,
                        RepairTime: asset.repairTime,
                        replaced: asset.details,
                        location: item.assetLocation,
                        distributionBox: item.distributionboxID,
                        customFields: asset.customFields,
                        logbookdate: asset.logbookDateTime,
                        warranty: asset.warrantyUpto,
                        remarks: asset.remarks,
                        additionalInfo: asset.additionalInformation,
                      });
                    });
                    setAssetDemoRR(testReport);
                    setAssetRR(testReport);
                    console.log(testReport);
                    setLoading(false);
                  }
                })
                .then((error) => {
                  console.log(error);
                });
            });
          } else {
            //setAssetDemo(testReport);
            //setAssets(cloneDeep(testReport.slice(0, countPerPage)));
            setLoading(false);
          }
        })
        .catch((error) => {
          setAssetDemoRR([]);
          setAssetRR([]);
          //setAssets([]);
          console.log(error);
        });
      */
      }
    } catch (error) {
      console.error(error);
    }
  }

  //---Repair/replace for single site and single distribution board
  async function getAssetsRRSingleDBSite(siteId, dbid) {
    //--
    try {
      let nextToken = "";
      let assets = [];
      await client
        .graphql({
          query: queries.assetsBySitedetailsID,
          variables: {
            sitedetailsID: siteId,
            limit: limit,
            filter: {
              status: {
                ne: "delete",
              },
            },
          },
          authMode: "API_KEY",
        })
        .then(async (result) => {
          let assetDatas = result.data.assetsBySitedetailsID.items;
          nextToken = result.data.assetsBySitedetailsID.nextToken;
          if (result.data.assetsBySitedetailsID.items.length > 0) {
            assets.push(assetDatas);
          }
          while (nextToken !== null) {
            await client
              .graphql({
                query: queries.assetsBySitedetailsID,
                variables: {
                  sitedetailsID: siteId,
                  limit: limit,
                  filter: {
                    status: {
                      ne: "delete",
                    },
                  },
                  nextToken: nextToken,
                },
                authMode: "API_KEY",
              })
              .then((results) => {
                nextToken = results.data.assetsBySitedetailsID.nextToken;

                if (results.data.assetsBySitedetailsID.items.length > 0) {
                  assets.push(results.data.assetsBySitedetailsID.items);
                }
              })
              .catch((error) => {
                console.log(error);
              });
          }
          console.log(assets);
          if (assets.length > 0) {
            const mergeAssets = assets.flat(1);
            console.log(mergeAssets);
            //--
            const asset = mergeAssets;
            const assetlist = asset.filter(
              (item) => item.distributionboxID === dbid
            );
            let testReport1 = assetlist.filter((it) => {
              const _matchingAssetTemplate = data.assetTemp?.find(
                (temp) => temp === it?.assettemplateID
              );
              if (_matchingAssetTemplate) {
                return it;
              }
            });
            console.log(testReport1);
            const testReport = [];
            if (testReport1.length > 0) {
              let nextToken1 = "";
              testReport1.map(async (item) => {
                let assets1 = [];
                await client
                  .graphql({
                    query: queries.repairsByAssetsID,
                    variables: {
                      limit: limit,
                      assetsID: item.id
                      // filter: {
                      //   assetsID: {
                      //     eq: item.id,
                      //   },
                      // },
                    },
                    authMode: "API_KEY",
                  })
                  .then(async (result) => {
                    let assetDatas = result.data.repairsByAssetsID.items;
                    nextToken1 = result.data.repairsByAssetsID.nextToken;
                    console.log(
                      "first token count",
                      result.data.repairsByAssetsID.items.length
                    );
                    console.log("nextToken 1", nextToken1);
                    if (result.data.repairsByAssetsID.items.length > 0) {
                      assets1.push(assetDatas);
                    }
                    while (nextToken1 !== null) {
                      await client
                        .graphql({
                          query: queries.repairsByAssetsID,
                          variables: {
                            limit: limit,
                            assetsID: item.id,
                            // filter: {
                            //   assetsID: {
                            //     eq: item.id,
                            //   },
                            // },
                            nextToken: nextToken1,
                          },
                          authMode: "API_KEY",
                        })
                        .then((results) => {
                          nextToken1 = results.data.repairsByAssetsID.nextToken;

                          if (results.data.repairsByAssetsID.items.length > 0) {
                            assets1.push(results.data.repairsByAssetsID.items);
                          }
                        })
                        .catch((error) => {
                          console.log(error);
                        });
                    }
                    console.log(assets1);
                    if (assets1.length > 0) {
                      const mergeAssets1 = assets1.flat(1);
                      console.log(mergeAssets1);
                      //-

                      const testing = mergeAssets1;
                      console.log(testing);
                      if (testing.length > 0) {
                        testing.map((asset) => {
                          testReport.push({
                            id: asset.id,
                            asset: item.fittingNumber,
                            assetsID: item.id,
                            RepairDate: asset.repairDate,
                            RepairTime: asset.repairTime,
                            replaced: asset.details,
                            location: item.assetLocation,
                            distributionBox: item.distributionboxID,
                            customFields: asset.customFields,
                            logbookdate: asset.logbookDateTime,
                            warranty: asset.warrantyUpto,
                            remarks: asset.remarks,
                            additionalInfo: asset.additionalInformation,
                          });
                        });
                        setAssetDemoRR(testReport);
                        setAssetRR(testReport);
                        console.log(testReport);
                        //setLoading(false);
                      }
                    }
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              });
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.error(error);
    }
    {
      /*
    await client.graphql({
      query: queries.assetsBySitedetailsID,
      variables: {
        sitedetailsID: siteId,
        limit: 20000,
      },
      authMode: "API_KEY",
    })
      .then((result) => {
        console.log(result);
        const asset = result.data.assetsBySitedetailsID.items;
        const assetlist = asset.filter(item => item.distributionboxID === dbid)
        let testReport1 = assetlist.filter((it) => {
          const _matchingAssetTemplate = data.assetTemp?.find(
            (temp) => temp === it?.assettemplateID
          );
          if (_matchingAssetTemplate) {
            return it;
          }
        });
        console.log(testReport1)
        const testReport = [];
        if (testReport1.length > 0) {
          testReport1.map((item) => {
            client.graphql({
              query: queries.listRepairs,
              variables: {
                limit: 20000,
                filter: {
                  assetsID: {
                    eq: item.id,
                  },
                },
              },
            })
              .then((testData) => {
                const testing = testData.data.listRepairs.items;
                console.log(testing);
                if (testing.length > 0) {
                  testing.map((asset) => {
                    testReport.push({
                      id: asset.id,
                      asset: item.fittingNumber,
                      assetsID: item.id,
                      RepairDate: asset.repairDate,
                      RepairTime: asset.repairTime,
                      replaced: asset.details,
                      location: item.assetLocation,
                      distributionBox: item.distributionboxID,
                      customFields: asset.customFields,
                      logbookdate: asset.logbookDateTime,
                      warranty: asset.warrantyUpto,
                      remarks: asset.remarks,
                      additionalInfo: asset.additionalInformation,
                    });
                  });
                  setAssetDemoRR(testReport);
                  setAssetRR(testReport);
                  console.log(testReport);
                  setLoading(false);
                }
              })
              .then((error) => {
                console.log(error);
              });
          });
        } else {
          //setAssetDemo(testReport);
          //setAssets(cloneDeep(testReport.slice(0, countPerPage)));
          setLoading(false);
        }
      })
      .catch((error) => {
        setAssetDemoRR([]);
        setAssetRR([]);
        //setAssets([]);
        console.log(error);
      });
    */
    }
  }

  // Repair and replace for all site and all distribution for ao
  async function getAssetsRRDemo() {
    //setLoading(true);
    //--
    try {
      let nextToken = "";
      let assets = [];
      await client
        .graphql({
          query: queries.siteDetailsByAssetownerID,
          variables: {
            assetownerID: LoginUserDetails.id,
            limit: limit,
          },
          authMode: "API_KEY",
        })
        .then(async (result) => {
          let assetDatas = result.data.siteDetailsByAssetownerID.items;
          nextToken = result.data.siteDetailsByAssetownerID.nextToken;
          if (result.data.siteDetailsByAssetownerID.items.length > 0) {
            assets.push(assetDatas);
          }
          while (nextToken !== null) {
            await client
              .graphql({
                query: queries.siteDetailsByAssetownerID,
                variables: {
                  assetownerID: LoginUserDetails.id,
                  limit: limit,
                  nextToken: nextToken,
                },
                authMode: "API_KEY",
              })
              .then((results) => {
                nextToken = results.data.siteDetailsByAssetownerID.nextToken;

                if (results.data.siteDetailsByAssetownerID.items.length > 0) {
                  assets.push(results.data.siteDetailsByAssetownerID.items);
                }
              })
              .catch((error) => {
                console.log(error);
              });
          }
          console.log(assets);
          if (assets.length > 0) {
            const mergeAssets = assets.flat(1);
            console.log(mergeAssets);
            //--
            let nextToken1 = "";
            let assets1 = [];
            mergeAssets.map(async (item) => {
              await client
                .graphql({
                  query: queries.assetsBySitedetailsID,
                  variables: {
                    sitedetailsID: item.id,
                    filter: {
                      status: {
                        ne: "delete",
                      },
                    },
                    limit: limit,
                  },
                  authMode: "API_KEY",
                })
                .then(async (result) => {
                  let assetDatas = result.data.assetsBySitedetailsID.items;
                  nextToken1 = result.data.assetsBySitedetailsID.nextToken;
                  console.log(
                    "first token count",
                    result.data.assetsBySitedetailsID.items.length
                  );
                  console.log("nextToken 1", nextToken1);
                  if (result.data.assetsBySitedetailsID.items.length > 0) {
                    assets1.push(assetDatas);
                  }
                  while (nextToken1 !== null) {
                    await client
                      .graphql({
                        query: queries.assetsBySitedetailsID,
                        variables: {
                          sitedetailsID: item.id,
                          filter: {
                            status: {
                              ne: "delete",
                            },
                          },
                          limit: limit,
                          nextToken: nextToken1,
                        },
                        authMode: "API_KEY",
                      })
                      .then((results) => {
                        nextToken1 =
                          results.data.assetsBySitedetailsID.nextToken;

                        if (
                          results.data.assetsBySitedetailsID.items.length > 0
                        ) {
                          assets1.push(
                            results.data.assetsBySitedetailsID.items
                          );
                        }
                      })
                      .catch((error) => {
                        console.log(error);
                      });
                  }
                  console.log(assets1);
                  if (assets1.length > 0) {
                    const mergeAssets1 = assets1.flat(1);
                    console.log(mergeAssets1);
                    //--
                    let testReport2 = mergeAssets1.filter((it) => {
                      const _matchingAssetTemplate = data.assetTemp?.find(
                        (temp) => temp === it?.assettemplateID
                      );
                      if (_matchingAssetTemplate) {
                        return it;
                      }
                    });
                    console.log(testReport2);
                    let testReport = [];
                    //---
                    if (testReport2.length > 0) {
                      let nextToken2 = "";
                      testReport2.map(async (item) => {
                        await sleep(Math.random() * item * 17);
                        let assets2 = [];
                        await client
                          .graphql({
                            query: queries.repairsByAssetsID,
                            variables: {
                              limit: limit,
                              assetsID: item.id,
                              // filter: {
                              //   assetsID: {
                              //     eq: item.id,
                              //   },
                              // },
                            },
                            authMode: "API_KEY",
                          })
                          .then(async (result) => {
                            let assetDatas = result.data.repairsByAssetsID.items;
                            nextToken2 = result.data.repairsByAssetsID.nextToken;
                            console.log(
                              "first token count",
                              result.data.repairsByAssetsID.items.length
                            );
                            console.log("nextToken 1", nextToken2);
                            if (result.data.repairsByAssetsID.items.length > 0) {
                              assets2.push(assetDatas);
                            }
                            while (nextToken2 !== null) {
                              await client
                                .graphql({
                                  query: queries.repairsByAssetsID,
                                  variables: {
                                    limit: limit,
                                    assetsID: item.id,
                                    // filter: {
                                    //   assetsID: {
                                    //     eq: item.id,
                                    //   },
                                    // },
                                    nextToken: nextToken2,
                                  },
                                  authMode: "API_KEY",
                                })
                                .then((results) => {
                                  nextToken2 =
                                    results.data.repairsByAssetsID.nextToken;

                                  if (
                                    results.data.repairsByAssetsID.items.length > 0
                                  ) {
                                    assets2.push(
                                      results.data.repairsByAssetsID.items
                                    );
                                  }
                                })
                                .catch((error) => {
                                  console.log(error);
                                });
                            }
                            console.log(assets2);
                            if (assets2.length > 0) {
                              const mergeAssets2 = assets2.flat(1);
                              console.log(mergeAssets2);
                              //-

                              const testing = mergeAssets2;
                              console.log(testing);
                              if (testing.length > 0) {
                                testing.map((asset) => {
                                  testReport.push({
                                    id: asset.id,
                                    asset: item.fittingNumber,
                                    assetsID: item.id,
                                    RepairDate: asset.repairDate,
                                    RepairTime: asset.repairTime,
                                    replaced: asset.details,
                                    location: item.assetLocation,
                                    distributionBox: item.distributionboxID,
                                    customFields: asset.customFields,
                                    logbookdate: asset.logbookDateTime,
                                    warranty: asset.warrantyUpto,
                                    remarks: asset.remarks,
                                    additionalInfo: asset.additionalInformation,
                                  });
                                });
                                setAssetDemoRR(testReport);
                                setAssetRR(testReport);
                                console.log(testReport);
                                //setLoading(false);
                              }
                            } else {
                              setAssetDemoRR([]);
                              setAssetRR([]);
                              console.log([]);
                              //setLoading(false);
                            }
                          })
                          .catch((error) => {
                            console.log(error);
                            setAssetDemoRR([]);
                            setAssetRR([]);
                            console.log([]);
                            //setLoading(false);
                          });
                      });
                    } else {
                      setAssetDemoRR([]);
                      setAssetRR([]);
                      console.log([]);
                      //setLoading(false);
                    }
                  }
                })
                .catch((error) => {
                  console.log(error);
                  setAssetDemoRR([]);
                  setAssetRR([]);
                  console.log([]);
                  //setLoading(false);
                });
            });
          }
        })
        .catch((error) => {
          console.error(error);
          setAssetDemoRR([]);
          setAssetRR([]);
          console.log([]);
          //setLoading(false);
        });
    } catch (error) {
      console.error(error);
    }
    {
      /*
    await client.graphql({
      query: queries.siteDetailsByAssetownerID,
      variables: {
        assetownerID: LoginUserDetails.id,
        limit: 2000000,
      },
      authMode: "API_KEY",
    })
      .then((sites) => {
        console.log(sites);
        let siteIds = [];
        if (sites.data.siteDetailsByAssetownerID.items.length > 0) {
          sites.data.siteDetailsByAssetownerID.items.map((item) => {
            siteIds.push(item.id);
          });
          const promises = sites.data.siteDetailsByAssetownerID.items.map(
            async (siteee) => {
              return client.graphql({
                query: queries.assetsBySitedetailsID,
                variables: {
                  sitedetailsID: siteee.id,
                  filter: {
                    status: {
                      eq: "Active",
                    },
                  },
                  limit: 2000000,
                },
              });
            }
          );
          Promise.all(promises)
            .then((results) => {
              const testReport1 = [];
              let testReport = [];
              results.forEach((result1) => {
                const assetList = result1.data.assetsBySitedetailsID.items;
                //console.log(assetList);
                if (assetList.length > 0) {
                  console.log(assetList);
                  testReport1.push(...assetList);
                }
              });
              console.log("final data");
              console.log(testReport1);
              let testReport2 = testReport1.filter((it) => {
                const _matchingAssetTemplate = data.assetTemp?.find(
                  (temp) => temp === it?.assettemplateID
                );
                if (_matchingAssetTemplate) {
                  return it;
                }
              });
              console.log(testReport2)
              //---
              if (testReport2.length > 0) {
                testReport2.map((item) => {
                  client.graphql({
                    query: queries.listRepairs,
                    variables: {
                      limit: 2000000,
                      filter: {
                        assetsID: {
                          eq: item.id,
                        },
                      },
                    },
                  })
                    .then((testData) => {
                      const testing = testData.data.listRepairs.items;
                      console.log(testing);
                      if (testing.length > 0) {
                        testing.map((asset) => {
                          testReport.push({
                            id: asset.id,
                            asset: item.fittingNumber,
                            assetsID: item.id,
                            RepairDate: asset.repairDate,
                            RepairTime: asset.repairTime,
                            replaced: asset.details,
                            location: item.assetLocation,
                            distributionBox: item.distributionboxID,
                            customFields: asset.customFields,
                            logbookdate: asset.logbookDateTime,
                            warranty: asset.warrantyUpto,
                            remarks: asset.remarks,
                            additionalInfo: asset.additionalInformation,
                          });
                        });
                        setAssetDemoRR(testReport);
                        setAssetRR(testReport);
                        console.log(testReport);
                        setLoading(false);
                      }
                    })
                    .then((error) => {
                      console.log(error);
                    });
                });
              } else {
                setAssetDemoRR([]);
                setAssetRR([]);
                setLoading(false);
              }
            })
            .catch((error) => {
              console.log(error);
              setErrorMessage("Unable to fetch the list");
            });
        } else {
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
    */
    }
  }

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  // Repair and replace for all site and all distribution for site user

  async function fetchRRSU() {
    //-
    try {
      let nextToken = "";
      let assets = [];
      await client
        .graphql({
          query: queries.linkUsersAndSitesByUserdetailsID,
          authMode: "API_KEY",
          variables: {
            userdetailsID: LoginUserDetails.id,
            filter: {
              status: {
                eq: "Active",
              },
            },
            limit: limit,
          },
        })
        .then(async (result) => {
          let assetDatas = result.data.linkUsersAndSitesByUserdetailsID.items;
          nextToken = result.data.linkUsersAndSitesByUserdetailsID.nextToken;
          if (result.data.linkUsersAndSitesByUserdetailsID.items.length > 0) {
            assets.push(assetDatas);
          }
          while (nextToken !== null) {
            await client
              .graphql({
                query: queries.linkUsersAndSitesByUserdetailsID,
                authMode: "API_KEY",
                variables: {
                  userdetailsID: LoginUserDetails.id,
                  filter: {
                    status: {
                      eq: "Active",
                    },
                  },
                  limit: limit,
                  nextToken: nextToken,
                },
              })
              .then((results) => {
                nextToken =
                  results.data.linkUsersAndSitesByUserdetailsID.nextToken;

                if (
                  results.data.linkUsersAndSitesByUserdetailsID.items.length > 0
                ) {
                  assets.push(
                    results.data.linkUsersAndSitesByUserdetailsID.items
                  );
                }
              })
              .catch((error) => {
                console.log(error);
              });
          }
          console.log(assets);
          if (assets.length > 0) {
            const mergeAssets = assets.flat(1);
            console.log(mergeAssets);
            //--
            let nextToken1 = "";
            let assets1 = [];
            mergeAssets.map(async (item) => {
              await client
                .graphql({
                  query: queries.assetsBySitedetailsID,
                  variables: {
                    sitedetailsID: item.sitedetailsID,
                    filter: {
                      status: {
                        ne: "delete",
                      },
                    },
                    limit: limit,
                  },
                  authMode: "API_KEY",
                })
                .then(async (result) => {
                  let assetDatas = result.data.assetsBySitedetailsID.items;
                  nextToken1 = result.data.assetsBySitedetailsID.nextToken;
                  console.log(
                    "first token count",
                    result.data.assetsBySitedetailsID.items.length
                  );
                  console.log("nextToken 1", nextToken1);
                  if (result.data.assetsBySitedetailsID.items.length > 0) {
                    assets1.push(assetDatas);
                  }
                  while (nextToken1 !== null) {
                    await client
                      .graphql({
                        query: queries.assetsBySitedetailsID,
                        variables: {
                          sitedetailsID: item.sitedetailsID,
                          limit: limit,
                          filter: {
                            status: {
                              ne: "delete",
                            },
                          },
                          nextToken: nextToken1,
                        },
                        authMode: "API_KEY",
                      })
                      .then((results) => {
                        nextToken1 =
                          results.data.assetsBySitedetailsID.nextToken;

                        if (
                          results.data.assetsBySitedetailsID.items.length > 0
                        ) {
                          assets1.push(
                            results.data.assetsBySitedetailsID.items
                          );
                        }
                      })
                      .catch((error) => {
                        console.log(error);
                      });
                  }
                  console.log(assets1);
                  if (assets1.length > 0) {
                    const mergeAssets1 = assets1.flat(1);
                    console.log(mergeAssets1);
                    //--
                    let testReport2 = mergeAssets1.filter((it) => {
                      const _matchingAssetTemplate = data.assetTemp?.find(
                        (temp) => temp === it?.assettemplateID
                      );
                      if (_matchingAssetTemplate) {
                        return it;
                      }
                    });
                    console.log(testReport2);
                    let testReport = [];
                    //---
                    if (testReport2.length > 0) {
                      let nextToken2 = "";
                      testReport2.map(async (item) => {
                        let assets2 = [];
                        await client
                          .graphql({
                            query: queries.listRepairs,
                            variables: {
                              limit: limit,
                              filter: {
                                assetsID: {
                                  eq: item.id,
                                },
                              },
                            },
                            authMode: "API_KEY",
                          })
                          .then(async (result) => {
                            let assetDatas = result.data.listRepairs.items;
                            nextToken2 = result.data.listRepairs.nextToken;
                            console.log(
                              "first token count",
                              result.data.listRepairs.items.length
                            );
                            console.log("nextToken 1", nextToken2);
                            if (result.data.listRepairs.items.length > 0) {
                              assets2.push(assetDatas);
                            }
                            while (nextToken2 !== null) {
                              await client
                                .graphql({
                                  query: queries.listRepairs,
                                  variables: {
                                    limit: limit,
                                    filter: {
                                      assetsID: {
                                        eq: item.id,
                                      },
                                    },
                                    nextToken: nextToken2,
                                  },
                                  authMode: "API_KEY",
                                })
                                .then((results) => {
                                  nextToken2 =
                                    results.data.listRepairs.nextToken;

                                  if (
                                    results.data.listRepairs.items.length > 0
                                  ) {
                                    assets2.push(
                                      results.data.listRepairs.items
                                    );
                                  }
                                })
                                .catch((error) => {
                                  console.log(error);
                                });
                            }
                            console.log(assets2);
                            if (assets2.length > 0) {
                              const mergeAssets2 = assets2.flat(1);
                              console.log(mergeAssets2);
                              //-

                              const testing = mergeAssets2;
                              console.log(testing);
                              if (testing.length > 0) {
                                testing.map((asset) => {
                                  testReport.push({
                                    id: asset.id,
                                    asset: item.fittingNumber,
                                    assetsID: item.id,
                                    RepairDate: asset.repairDate,
                                    RepairTime: asset.repairTime,
                                    replaced: asset.details,
                                    location: item.assetLocation,
                                    distributionBox: item.distributionboxID,
                                    customFields: asset.customFields,
                                    logbookdate: asset.logbookDateTime,
                                    warranty: asset.warrantyUpto,
                                    remarks: asset.remarks,
                                    additionalInfo: asset.additionalInformation,
                                  });
                                });
                                setAssetDemoRR(testReport);
                                setAssetRR(testReport);
                                console.log(testReport);
                                //setLoading(false);
                              }
                            } else {
                              setAssetDemoRR([]);
                              setAssetRR([]);
                              console.log([]);
                              //setLoading(false);
                            }
                          })
                          .catch((error) => {
                            console.log(error);
                            setAssetDemoRR([]);
                            setAssetRR([]);
                            console.log([]);
                            //setLoading(false);
                          });
                      });
                    } else {
                      setAssetDemoRR([]);
                      setAssetRR([]);
                      console.log([]);
                      //setLoading(false);
                    }
                  }
                })
                .catch((error) => {
                  console.log(error);
                  setAssetDemoRR([]);
                  setAssetRR([]);
                  console.log([]);
                  //setLoading(false);
                });
            });
          }
        })
        .catch((error) => {
          console.error(error);
          setAssetDemoRR([]);
          setAssetRR([]);
          console.log([]);
          //setLoading(false);
        });
    } catch (error) {
      console.error(error);
    }

    {
      /*
    await client.graphql({
      query: queries.linkUsersAndSitesByUserdetailsID,
      authMode: "API_KEY",
      variables: {
        userdetailsID: LoginUserDetails.id,
        limit: 2000000,
      },
    })
      .then((dataDetails) => {
        const siteDetails =
          dataDetails.data.linkUsersAndSitesByUserdetailsID.items;
        if (siteDetails.length > 0) {
          client.graphql({
            query: queries.listSiteDetails,
            variables: {
              limit: 2000000,
            },
          })
            .then((result) => {
              console.log(result);
              const siteDetail = result.data.listSiteDetails.items.filter(
                (item) => {
                  const _matchingAssetTemplate = siteDetails?.find(
                    (site) => site.sitedetailsID === item?.id
                  );
                  if (_matchingAssetTemplate) {
                    return item;
                  }
                }
              );
              console.log();
              let siteIds = [];
              if (siteDetail.length > 0) {
                siteDetail.map((item) => {
                  siteIds.push(item.id);
                });
                const promises = siteDetail.map(
                  async (siteee) => {
                    return client.graphql({
                      query: queries.assetsBySitedetailsID,
                      variables: {
                        sitedetailsID: siteee.id,
                        filter: {
                          status: {
                            eq: "Active",
                          },
                        },
                        limit: 2000000,
                      },
                    });
                  }
                );
                Promise.all(promises)
                  .then((results) => {
                    const testReport1 = [];
                    let testReport = [];
                    results.forEach((result1) => {
                      const assetList = result1.data.assetsBySitedetailsID.items;
                      //console.log(assetList);
                      if (assetList.length > 0) {
                        testReport1.push(...assetList);
                      }
                    });
                    console.log("final data");
                    console.log(testReport1);
                    let testReport2 = testReport1.filter((it) => {
                      const _matchingAssetTemplate = data.assetTemp?.find(
                        (temp) => temp === it?.assettemplateID
                      );
                      if (_matchingAssetTemplate) {
                        return it;
                      }
                    });
                    console.log(testReport2)
                    //--
                    if (testReport2.length > 0) {
                      testReport2.map((item) => {
                        client.graphql({
                          query: queries.listRepairs,
                          variables: {
                            limit: 2000000,
                            filter: {
                              assetsID: {
                                eq: item.id,
                              },
                            },
                          },
                        })
                          .then((testData) => {
                            const testing = testData.data.listRepairs.items;
                            console.log(testing);
                            if (testing.length > 0) {
                              testing.map((asset) => {
                                testReport.push({
                                  id: asset.id,
                                  asset: item.fittingNumber,
                                  assetsID: item.id,
                                  RepairDate: asset.repairDate,
                                  RepairTime: asset.repairTime,
                                  replaced: asset.details,
                                  location: item.assetLocation,
                                  distributionBox: item.distributionboxID,
                                  customFields: asset.customFields,
                                  logbookdate: asset.logbookDateTime,
                                  warranty: asset.warrantyUpto,
                                  remarks: asset.remarks,
                                  additionalInfo: asset.additionalInformation,
                                });
                              });
                              setAssetDemoRR(testReport);
                              setAssetRR(testReport);
                              console.log(testReport);
                              setLoading(false);
                            }
                          })
                          .then((error) => {
                            console.log(error);
                          });
                      });
                    } else {
                      setAssetDemoRR([]);
                      setAssetRR([]);
                      setLoading(false);
                    }
                  })
                  .catch((error) => {
                    console.log(error);
                    setErrorMessage("Unable to fetch the list");
                  });
              } else {
                setAssetDemoRR([]);
                setAssetRR([]);
                setLoading(false);
              }
            })
            .catch((error2) => {
              console.log(error2);
            });
        } else {
          setAssetDemoRR([]);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
    */
    }
  }

  const updatePage = (p) => {
    setCurrentPage(p);
    const to = countPerPage * p;
    const from = to - countPerPage;
    setAssets(cloneDeep(assetDemo.slice(from, to)));
  };

  // ----site user invited by ao
  async function fetchSUByAo() {
    try {
      const result = await client
        .graphql({
          query: queries.getUserDetails,
          variables: {
            id: LoginUserDetails.id,
            limit: limit,
            // filter: {
            //   id: {
            //     eq: LoginUserDetails.id,
            //   },
            // },
          },
          authMode: "API_KEY",
        });
      if (result.data.getUserDetails !== null) {
        console.log(result);
        const aoid = result.data.getUserDetails.assetOwnerId;
        console.log(aoid);
        const result2 = await client
          .graphql({
            query: queries.getAssetOwner,
            variables: {
              id: aoid,
              limit: limit,
              // filter: {
              //   id: {
              //     eq: aoid,
              //   },
              // },
            },
            authMode: "API_KEY",
          })
        if (result2.data.getAssetOwner !== null) {
          console.log(result2);
          setAo(result2.data.getAssetOwner);
          getfilename(result2.data.getAssetOwner.profilePicture);
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  // AO details
  async function getAO() {
    try {
      await client
        .graphql({
          query: queries.listAssetOwners,
          variables: {
            limit: limit,
            filter: {
              id: {
                eq: LoginUserDetails.id,
              },
            },
          },
          authMode: "API_KEY",
        })
        .then((result) => {
          console.log(result);
          setAo(result.data.listAssetOwners.items[0]);
          getfilename(result.data.listAssetOwners.items[0].profilePicture);
          console.log(result.data.listAssetOwners.items[0].profilePicture);
        })
        .catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.error(error);
    }
  }

  const getImage = async (filename) => {
    try {
      var params = {
        Bucket: S3_BUCKET,
        Key: `public/${ASSET_OWNER_FOLDER}/${filename}`,
      };
      return myBucket
        .getSignedUrlPromise("getObject", params)
        .then(function (url) {
          console.log(url);
          setdownloadedFile(url);
          return url; // return the signed URL
        })
        .catch(function (err) {
          console.log(err);
          return ""; // fallback if error
        });
    } catch (error) {
      console.log("Error while fetching:", error);

      return "";
    }
    //   var promise = myBucket.getSignedUrlPromise("getObject", params);
    //   promise.then(
    //     function (url) {
    //       console.log(url);
    //       setdownloadedFile(url);
    //       setselectedImg(url);
    //     },
    //     function (err) {
    //       console.log(err);
    //     }
    //   );
    // } catch (error) {
    //   console.error("Error while fetching:", error);
    // }
  };
  //-------------------------------------------------------------------------
  function getfilename(path) {
    try {
      const files = JSON.parse(path);
      if (files.length > 0) {
        var newfilename = files[0].fileName;
        getImage(newfilename);
      }
    } catch (error) {
      console.error("Error parsing JSON input:", error);
    }
  }

  const getBase64ImageFromUrl = async (imageUrl) => {
    const response = await fetch(imageUrl);
    const blob = await response.blob();

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  //----pdf---
  const generatePDFdemo = async () => {
    try {
      const doc = new jsPDF("portrait", "pt", "A4");
      //const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      doc.setFont("helvetica", "normal");
      const base64Logo = await getBase64ImageFromUrl(KYASPLogo);
      const pageWidth = doc.internal.pageSize.getWidth();
      const logoWidth = 50;
      const logoHeight = 50;
      const logoX = (pageWidth - logoWidth) / 2;
      const logoY = 25;
      doc.addImage(base64Logo, "PNG", logoX, logoY, logoWidth, logoHeight);

      doc.setFontSize(8);
      const subtextY = logoY + logoHeight + 6;
      // doc.text("Report generated by Know Your Asset", pageWidth / 2, subtextY, {
      //   align: "center",
      // });
      const textWidth =
        doc.getStringUnitWidth("Logbook") * doc.internal.getFontSize();
      const textOffset = (pageWidth - textWidth) / 2;

      // headingY = 20;
      // doc.text("Logbook Report", textOffset, headingY);

      //const imageY = headingY + 10;

      // if (downloadedFile != null) {
      //   try {
      //     doc.addImage(downloadedFile, "JPEG", textOffset + 10, imageY, 50, 50);
      //   } catch (error) {
      //     console.error("Error while adding image to document:", error);
      //   }
      // }

      const marginLeft = 20;
      let cursorY = logoY;

      const categoryName = data.categoryName || "-";
      const testRes = data.testResult === "" ? "All" : data.testResult || "-";
      const daysAgo = parseInt(data.date);
      const testDate = moment().subtract(daysAgo, "days").format("DD/MM/YYYY");
      const currentDate = moment().format("DD/MM/YYYY");

      const unitNumber = sites && sites.unitNumber ? sites.unitNumber : "-";

      doc.setFontSize(6.5).setTextColor(40);
      doc.text(`Category: ${categoryName} Logbook Report`, marginLeft, cursorY);
      cursorY += 10;
      // doc.text(`Site: ${sites?.siteName}`, marginLeft, cursorY);
      // cursorY += 10;      
      doc.text(`Site Address: ${unitNumber}`, marginLeft, cursorY);
      cursorY += 10;
      doc.text(`Distribution Board: ${data.distributionBox === "allDistribution"
        ? "All Distribution"
        : distributionBox.map((item) => item.distributionBoxName)}`, marginLeft, cursorY);
      cursorY += 10;
      doc.text(`Maintenance Contractor: ${mc?.username || "N/A"}`, marginLeft, cursorY);
      // doc.setFontSize(7);
      // doc.text(`Test Status: ${testRes}`, marginLeft, cursorY);
      cursorY += 10;
      doc.text(`From: ${testDate} to ${currentDate}`, marginLeft, cursorY);
      doc.setTextColor(100);
      doc.text("Report generated by Know Your Asset", pageWidth / 2, logoY + 50 + 15, { align: "center" });


      doc.setFontSize(7).setTextColor(50);
      const textOffsetSite = 20;
      const siteDetailsHeadingY = logoY + 75;

      const siteInfoTableData = [
        ["Site Name", sites?.siteName || "All Sites"],
        ["Site Address", unitNumber],
        [
          "Distribution Board",
          data.distributionBox === "allDistribution"
            ? "All Distribution"
            : distributionBox.map((item) => item.distributionBoxName),
        ],
        ["Maintenance Contractor", mc?.username || "N/A"],
      ];

      const siteInfoTableStartY = siteDetailsHeadingY + 0;

      //const columnWidthsSite = [200, 315.28];
      //const pageWidth = doc.internal.pageSize.getWidth();
      const usableWidth = pageWidth - 40; // 20px margins
      const columnWidthsSite = [usableWidth * 0.35, usableWidth * 0.65];


      const siteInfoTableConfig = {
        startY: siteInfoTableStartY,
        headStyles: {
          fillColor: [0, 0, 0],
          textColor: [255, 255, 255],
        },
        bodyStyles: { textColor: [0, 0, 0] },
        margin: { left: 20, right: 20, top: 30 },
        tableWidth: doc.internal.pageSize.getWidth() - 20,
        tableLineColor: [0, 0, 0],
        tableLineWidth: 0.5,
        drawHeaderRow: (row, data) => {
          doc.setDrawColor(0, 0, 0);
          doc.setLineWidth(0.5);
          doc.line(
            data.settings.margin.left,
            row.y,
            data.settings.margin.right,
            row.y
          );
        },
        styles: { fontSize: 7, textColor: 50 },
      };

      // doc.autoTable({
      //   body: siteInfoTableData,
      //   startY: siteInfoTableStartY,
      //   margin: { left: 20, top: 30 },
      //   tableWidth: (doc.internal.pageSize.getWidth() - 20) + 20,
      //   tableLineWidth: 0, 
      //   headStyles: {
      //     fillColor: [220, 220, 220], 
      //     textColor: [0, 0, 0],
      //   },
      //   bodyStyles: {
      //     textColor: [0, 0, 0],
      //     fillColor: [245, 245, 245], 
      //   },
      //   styles: { fontSize: 7, textColor: 50 },
      //   columnStyles: {
      //     0: { cellWidth: columnWidthsSite[0], fillColor: [240, 240, 240] },
      //     1: { cellWidth: columnWidthsSite[1], fillColor: [245, 245, 245] },
      //   },
      // });

      // doc.autoTable({
      //   body: siteInfoTableData,
      //   startY: siteInfoTableStartY,
      //   ...siteInfoTableConfig,
      //   columnStyles: {
      //     0: { cellWidth: columnWidthsSite[0], fillColor: [220, 220, 220] },
      //     1: { cellWidth: columnWidthsSite[1] },
      //   },
      // });

      const textOffsetAO = 20;
      const AOHeadingY = siteDetailsHeadingY + 5;
      //doc.text("Asset Owner", textOffsetAO, AOHeadingY);

      const aof = ao && ao.firstName ? ao.firstName : "N/A";
      const aol = ao && ao.lastName ? ao.lastName : "N/A";
      const companyName =
        company && company.companyName ? company.companyName : "N/A";
      const companyBN =
        company && company.companyBN ? company.companyBN : "N/A";
      const companyAddress =
        company && company.companyAddress ? company.companyAddress : "N/A";

      const AOInfoTableData = [
        ["Name:", aof + " " + aol],
        ["Company Name:", companyName],
        ["Company BN#:", companyBN],
        ["Company Address:", companyAddress],
      ];

      const AOInfoTableStartY = AOHeadingY + 0;
      const AOInfoTableConfig = {
        startY: AOInfoTableStartY,
        headStyles: {
          fillColor: [0, 0, 0],
          textColor: [255, 255, 255],
        },
        bodyStyles: { textColor: [0, 0, 0] },
        margin: { left: 20, right: 20, top: 30 },
        tableWidth: doc.internal.pageSize.getWidth() - 40,
        tableLineColor: [0, 0, 0],
        tableLineWidth: 0.5,
        drawHeaderRow: (row, data) => {
          doc.setDrawColor(0, 0, 0);
          doc.setLineWidth(0.5);
          doc.line(
            data.settings.margin.left,
            row.y,
            data.settings.margin.right,
            row.y
          );
        },
        styles: { fontSize: 7 },
      };

      const columnWidths = [200, 315.28];

      doc.autoTable({
        body: AOInfoTableData,
        startY: AOInfoTableStartY,
        margin: { left: 20, right: 20, top: 20 },
        tableWidth: doc.internal.pageSize.getWidth(),
        tableLineWidth: 0, // remove table borders
        headStyles: {
          fillColor: [220, 220, 220],
          textColor: [0, 0, 0],
        },
        bodyStyles: {
          textColor: [0, 0, 0],
          fillColor: [245, 245, 245],
        },
        styles: { fontSize: 7 },
        columnStyles: {
          0: { cellWidth: columnWidthsSite[0], fillColor: [240, 240, 240] },
          1: { cellWidth: columnWidthsSite[1], fillColor: [245, 245, 245] },
        },
      });

      // logbook report heading
      const textOffsetlogbook = 20;
      const LogbookReportHeadingY = AOInfoTableStartY + 80;
      //doc.text("Logbook Report", textOffsetlogbook, LogbookReportHeadingY);
      const tableStartY = LogbookReportHeadingY + 0;
      const tableBody = [];

      // Group by Site - Location
      const groupedBySiteAndLocation = {};

      assetDemo.forEach((item) => {
        const site = sites?.siteName || "Unknown Site";
        const location = item.location || "Not mentioned";

        if (!groupedBySiteAndLocation[site]) {
          groupedBySiteAndLocation[site] = {};
        }

        if (!groupedBySiteAndLocation[site][location]) {
          groupedBySiteAndLocation[site][location] = [];
        }

        groupedBySiteAndLocation[site][location].push([
          item.asset,
          location,
          getDB(item.distributionBox),
          moment(item.warranty).format("DD/MM/YYYY"),
          item.customFields || "-",
        ]);
      });

      Object.entries(groupedBySiteAndLocation).forEach(([site, locations]) => {
        tableBody.push([
          {
            content: `Site: ${site}`,
            colSpan: 10,
            styles: {
              fillColor: [220, 235, 255],
              fontStyle: "bold",
              textColor: [30, 30, 60],
            },
          },
        ]);

        Object.entries(locations).forEach(([location, rows]) => {
          tableBody.push([
            {
              content: `Location: ${location}`,
              colSpan: 10,
              styles: {
                fillColor: [240, 240, 240],
                fontStyle: "italic",
                textColor: [80, 80, 80],
              },
            },
          ]);

          tableBody.push(
            ...rows.map((row) =>
              row.map((cell) => ({
                content: cell,
                styles: { fontSize: 7, halign: "left", cellPadding: 3 },
              }))
            )
          );

          tableBody.push([{ content: "", colSpan: 10 }]);
        });
      });

      const columnHeaders = [
        [
          "Fitting Number",
          "Location",
          "Distribution Board",
          "Warranty Upto",
          "Custom Fields",
        ].map((col) => ({
          content: col,
          styles: {
            fillColor: [0, 0, 0],
            textColor: [255, 255, 255],
            fontStyle: "bold",
            halign: "center",
          },
        })),
      ];

      // Render the grouped table
      autoTable(doc, {
        head: columnHeaders,
        body: tableBody,
        startY: tableStartY,
        margin: { left: 20, right: 20, top: 80 },
        tableWidth: doc.internal.pageSize.getWidth() - 40,
        styles: {
          fontSize: 7,
          lineHeight: 1.1,
          cellPadding: 3,
          overflow: "linebreak",
          textColor: [0, 0, 0],
          fillColor: [255, 255, 255],
          lineWidth: 0.2,
          lineColor: [0, 0, 0],
        },
        didDrawPage: () => {
          const pageWidth = doc.internal.pageSize.getWidth();
          const pageHeight = doc.internal.pageSize.getHeight();
          const pageNumber = doc.internal.getNumberOfPages();
          const marginLeft = 20;
          const nowStr = moment().format("dddd, DD/MM/YYYY HH:mm");

          // Draw only from second page onward
          if (pageNumber > 1) {
            const logoW = 40,
              logoH = 40;
            const logoX = (pageWidth - logoW) / 2;
            const logoY = 20;
            doc.addImage(base64Logo, "PNG", logoX, logoY, logoW, logoH);

            // Header info
            let cursorY = logoY + 5;
            doc.setFontSize(6.5).setTextColor(40);
            doc.text(`Category: ${data.categoryName || "-"}`, marginLeft, cursorY);
            cursorY += 10;
            doc.text(`Site Address: ${unitNumber}`, marginLeft, cursorY);
            cursorY += 10;
            doc.text(`Distribution Board: ${data.distributionBox === "allDistribution"
              ? "All Distribution"
              : distributionBox.map((item) => item.distributionBoxName)}`, marginLeft, cursorY);
            cursorY += 10;
            doc.text(`Maintenance Contractor: ${mc?.username || "N/A"}`, marginLeft, cursorY);
            cursorY += 10;
            const testDate = moment().subtract(parseInt(data.date), "days").format("DD/MM/YYYY");
            const currDate = moment().format("DD/MM/YYYY");
            doc.text(`From: ${testDate} to ${currDate}`, marginLeft, cursorY);
            // Centered text below logo
            doc.setFontSize(6.5).setTextColor(100);
            doc.text(
              "Report generated by Know Your Asset",
              pageWidth / 2,
              logoY + logoH + 5,
              { align: "center" }
            );
          }

          // Page number and timestamp (every page)
          const topRightX = pageWidth - 20;
          doc.setFontSize(6.5).setTextColor(80);
          doc.text(`Page ${pageNumber}`, topRightX, 20, { align: "right" });
          doc.text(nowStr, topRightX, 30, { align: "right" });

        },
      }
      );

      const finalY = doc.lastAutoTable.finalY;
      // rapair replacement heading
      const RRHeadingY = finalY + 15;
      doc.setFontSize(9);
      doc.setFont("helvetica", "bold");
      const textOffsetRR = 20;
      //const RRHeadingY = tableStartY + (tableBody.length * 3) + 0;
      doc.text("Repair/Replacement Details", textOffsetRR, RRHeadingY);

      const tableHeaderRR = [
        "Fitting Number",
        "Warranty Upto",
        "Repair Date & Time",
        "Replaced Date",
        "Replaced",
        "Additional Information",
      ].map((col) => ({
        content: col,
        styles: {
          fillColor: [0, 0, 0],
          textColor: [255, 255, 255],
          fontStyle: "bold",
          halign: "center",
        },
      }));

      const tableDataRR = assetDemoRR.map((item) => {
        const repairDateTime =
          moment(item.RepairDate).format("DD/MM/YYYY") + " " + item.RepairTime;

        return [
          item.asset,
          item.warranty,
          repairDateTime,
          "", // Replaced Date (empty?)
          item.replaced,
          item.additionalInfo,
        ];
      });

      const tableStartYRR = RRHeadingY + 10;

      const tableConfigRR = {
        startY: tableStartYRR,
        headStyles: { fillColor: [0, 0, 0], textColor: [255, 255, 255] },
        margin: { top: 10, left: 20, right: 20 },
        tableLineColor: [0, 0, 0],
        tableLineWidth: 0.5,
        styles: {
          fontSize: 7,
          lineHeight: 1.1,
          cellPadding: 3,
          overflow: "linebreak",
          textColor: [0, 0, 0],
          fillColor: [255, 255, 255],
          lineWidth: 0.2,
          lineColor: [0, 0, 0],
        },
      };

      doc.autoTable({
        head: [tableHeaderRR.map((cell) => cell.content)],
        body: tableDataRR,
        ...tableConfigRR,
      });

      doc.save("LogbookReport.pdf");
    } catch (error) {
      console.error(error);
    }
  };

    const generatePDF = async () => {
    if (
      data.sites === "allSites" &&
      data.distributionBox === "allDistribution"
    ) {
      console.log("All site  and all distribution boards selected");

      toast.success(
        `We will email the logbook report to the logged-in user's email address once it is generated.`,
        {
          position: toast.POSITION.TOP_CENTER,
        }
      );
    } else if (
      data.sites !== "allSites" &&
      data.distributionBox === "allDistribution"
    ) {
      console.log("single site  and all distribution boards selected");
      toast.success(
        `We will email the logbook report to the logged-in user's email address once it is generated.`,
        {
          position: toast.POSITION.TOP_CENTER,
        }
      );
      try {
        const logoBase64 = await getBase64ImageFromUrl(KYASPLogo);
        await axios.post(
          "https://klc4ghif39.execute-api.ap-southeast-2.amazonaws.com/default/logbookReportAllsites",
          {
            sites: data.sites,
            AllSites: fullSites,
            siteData: "singleSite",
            distri: "",
            loggedInUser: LoginUserDetails.id,
            loggedInUsername: LoginUserDetails.username,
            dataa: data,
            email: LoginUserDetails.email,
            logoBase64: "",
            //ao: ao,
            //company: company,
            mc: mc,
            LoginUserGroup: LoginUserGroup
            //logoBase64: logoBase64,
            //imageBase64: downloadedFile,
          }
        );
      }
      catch (error) {
        console.error(error);
      }
      //---
    } else {
      console.log("single site  and single distribution boards selected");
      toast.success(
        `We will email the logbook report to the logged-in user's email address once it is generated.`,
        {
          position: toast.POSITION.TOP_CENTER,
        }
      );
      try {
        const logoBase64 = await getBase64ImageFromUrl(KYASPLogo);
        await axios.post(
          "https://klc4ghif39.execute-api.ap-southeast-2.amazonaws.com/default/logbookReportAllsites",
          {
            sites: data.sites,
            AllSites: fullSites,
            siteData: "singleSite",
            distri: data.distributionBox,
            loggedInUser: LoginUserDetails.id,
            loggedInUsername: LoginUserDetails.username,
            dataa: data,
            email: LoginUserDetails.email,
            logoBase64: logoBase64,
            //ao: ao,
            //company: company,
            mc: mc,
            LoginUserGroup: LoginUserGroup
            //logoBase64: logoBase64,
            //imageBase64: downloadedFile,
          }
        );
      } catch (error) {
        console.error("error ", error);
      }
    }
  }

  const filterAssets = (assetValue) => {
    console.log(assetValue);
    try {
      setAssetVal(assetValue);
      if (assetValue !== null && assetValue.value !== null) {
        var filterAssets = demofilter.filter((item) => {
          return item.id === assetValue.value;
        });
        if (dateRange[0] !== null) {
          const [newStartDate, newEndDate] = dateRange;
          var filterAssets1 = filterAssets.filter((item) => {
            return (
              moment(item.createdAt).format("DD/MM/YYYY") >=
              moment(newStartDate).format("DD/MM/YYYY") &&
              moment(item.createdAt).format("DD/MM/YYYY") <=
              moment(newEndDate).format("DD/MM/YYYY")
            );
          });
          const sort = filterAssets1.sort(
            (a, b) => b.fittingNumber - a.fittingNumber
          );
          setAssetDemo(sort);
          setAssets(cloneDeep(sort.slice(0, countPerPage)));

          //--RR filter
          var filterAssetsRR = assetRR.filter((item) => {
            return item.assetsID === assetValue.value;
          });
          console.log(filterAssetsRR);
          setAssetDemoRR(filterAssetsRR);
        } else if (warrantyDate !== null) {
          var filterAssets = demofilter.filter((item) => {
            return (
              moment(item.warranty).format("DD/MM/YYYY") ===
              moment(warrantyDate).format("DD/MM/YYYY")
            );
          });
          const sort = filterAssets.sort(
            (a, b) => b.fittingNumber - a.fittingNumber
          );
          setAssetDemo(sort);
          setAssets(cloneDeep(sort.slice(0, countPerPage)));
          //--
          var filterAssetsRR = assetRR.filter((item) => {
            return item.assetsID === assetValue.value;
          });
          console.log(filterAssetsRR);
          setAssetDemoRR(filterAssetsRR);
        } else {
          const sort = filterAssets.sort(
            (a, b) => b.fittingNumber - a.fittingNumber
          );
          setAssetDemo(sort);
          setAssets(cloneDeep(sort.slice(0, countPerPage)));
          //--
          var filterAssetsRR = assetRR.filter((item) => {
            return item.assetsID === assetValue.value;
          });
          console.log(filterAssetsRR);
          setAssetDemoRR(filterAssetsRR);
        }
      } else {
        if (dateRange[0] !== null) {
          const [newStartDate, newEndDate] = dateRange;
          var filterAssets = demofilter.filter((item) => {
            return (
              moment(item.createdAt).format("DD/MM/YYYY") >=
              moment(newStartDate).format("DD/MM/YYYY") &&
              moment(item.createdAt).format("DD/MM/YYYY") <=
              moment(newEndDate).format("DD/MM/YYYY")
            );
          });
          const sort = filterAssets.sort(
            (a, b) => b.fittingNumber - a.fittingNumber
          );
          setAssetDemo(sort);
          setAssets(cloneDeep(sort.slice(0, countPerPage)));
        } else if (warrantyDate !== null) {
          var filterAssets = demofilter.filter((item) => {
            return (
              moment(item.warranty).format("DD/MM/YYYY") ===
              moment(warrantyDate).format("DD/MM/YYYY")
            );
          });
          const sort = filterAssets.sort(
            (a, b) => b.fittingNumber - a.fittingNumber
          );
          setAssetDemo(sort);
          setAssets(cloneDeep(sort.slice(0, countPerPage)));
        } else {
          setAssetDemo(demofilter);
          setAssets(cloneDeep(demofilter.slice(0, countPerPage)));
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const filterDateRage = (value, value1) => {
    try {
      if (value !== null && value1 !== null) {
        var filterAssets = demofilter.filter((item) => {
          return (
            moment(item.createdAt).format("DD/MM/YYYY") >=
            moment(value).format("DD/MM/YYYY") &&
            moment(item.createdAt).format("DD/MM/YYYY") <=
            moment(value1).format("DD/MM/YYYY")
          );
        });
        if (assetVal !== null && assetVal !== "" && assetVal.value !== null) {
          var filterAssets1 = filterAssets.filter((item) => {
            return item.id === assetVal.value;
          });
          const sort = filterAssets1.sort(
            (a, b) => b.fittingNumber - a.fittingNumber
          );
          setAssetDemo(sort);
          setAssets(cloneDeep(sort.slice(0, countPerPage)));
        } else if (warrantyDate !== null) {
          var filterAssets = demofilter.filter((item) => {
            return (
              moment(item.warranty).format("DD/MM/YYYY") ===
              moment(warrantyDate).format("DD/MM/YYYY")
            );
          });
          const sort = filterAssets.sort(
            (a, b) => b.fittingNumber - a.fittingNumber
          );
          setAssetDemo(sort);
          setAssets(cloneDeep(sort.slice(0, countPerPage)));
        } else {
          const sort = filterAssets.sort(
            (a, b) => b.fittingNumber - a.fittingNumber
          );
          setAssetDemo(sort);
          setAssets(cloneDeep(sort.slice(0, countPerPage)));
        }
      } else {
        if (assetVal !== null && assetVal !== "" && assetVal.value !== null) {
          var filterAssets = demofilter.filter((item) => {
            return item.id === assetVal.value;
          });
          const sort = filterAssets.sort(
            (a, b) => b.fittingNumber - a.fittingNumber
          );
          setAssetDemo(sort);
          setAssets(cloneDeep(sort.slice(0, countPerPage)));
        } else if (warrantyDate !== null) {
          var filterAssets = demofilter.filter((item) => {
            return (
              moment(item.warranty).format("DD/MM/YYYY") ===
              moment(warrantyDate).format("DD/MM/YYYY")
            );
          });
          const sort = filterAssets.sort(
            (a, b) => b.fittingNumber - a.fittingNumber
          );
          setAssetDemo(sort);
          setAssets(cloneDeep(sort.slice(0, countPerPage)));
        } else {
          setAssetDemo(demofilter);
          setAssets(cloneDeep(demofilter.slice(0, countPerPage)));
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const filterWarrantyDate = (value) => {
    try {
      if (startDate !== null && endDate !== null) {
        var filterAssets1 = [];
        var filterAssets = demofilter.filter((item) => {
          return (
            moment(item.createdAt).format("DD/MM/YYYY") >=
            moment(startDate).format("DD/MM/YYYY") &&
            moment(item.createdAt).format("DD/MM/YYYY") <=
            moment(endDate).format("DD/MM/YYYY")
          );
        });
        if (assetVal !== null && assetVal !== "" && assetVal.value !== null) {
          filterAssets1 = filterAssets.filter((item) => {
            return item.id === assetVal.value;
          });
          const sort = filterAssets1.sort(
            (a, b) => b.fittingNumber - a.fittingNumber
          );
          setAssetDemo(sort);
          setAssets(cloneDeep(sort.slice(0, countPerPage)));
        }
        if (
          value !== null &&
          assetVal !== null &&
          assetVal !== "" &&
          assetVal.value !== null
        ) {
          var filterAssets2 = filterAssets1.filter((item) => {
            return (
              moment(item.warranty).format("DD/MM/YYYY") ===
              moment(value).format("DD/MM/YYYY")
            );
          });
          const sort = filterAssets2.sort(
            (a, b) => b.fittingNumber - a.fittingNumber
          );
          setAssetDemo(sort);
          setAssets(cloneDeep(sort.slice(0, countPerPage)));
        } else if (value !== null) {
          var filterAssets2 = filterAssets.filter((item) => {
            return (
              moment(item.warranty).format("DD/MM/YYYY") ===
              moment(value).format("DD/MM/YYYY")
            );
          });
          const sort = filterAssets2.sort(
            (a, b) => b.fittingNumber - a.fittingNumber
          );
          setAssetDemo(sort);
          setAssets(cloneDeep(sort.slice(0, countPerPage)));
        } else {
          setAssetDemo(demofilter);
          setAssets(cloneDeep(demofilter.slice(0, countPerPage)));
        }
      } else if (
        assetVal !== null &&
        assetVal !== "" &&
        assetVal.value !== null &&
        value !== null
      ) {
        var filterAssets = [];
        if (assetVal !== null && assetVal !== "" && assetVal.value !== null) {
          filterAssets = demofilter.filter((item) => {
            return item.id === assetVal.value;
          });
          const sort = filterAssets.sort(
            (a, b) => b.fittingNumber - a.fittingNumber
          );
          console.log(filterAssets);
          setAssetDemo(sort);
          setAssets(cloneDeep(sort.slice(0, countPerPage)));
        }

        if (value !== null) {
          console.log(filterAssets);
          var filterAssets1 = filterAssets.filter((item) => {
            return (
              moment(item.warranty).format("DD/MM/YYYY") ===
              moment(value).format("DD/MM/YYYY")
            );
          });
          const sort = filterAssets1.sort(
            (a, b) => b.fittingNumber - a.fittingNumber
          );
          setAssetDemo(sort);
          setAssets(cloneDeep(sort.slice(0, countPerPage)));
        } else if (
          value === null &&
          assetVal === null &&
          assetVal === "" &&
          assetVal.value === null
        ) {
          setAssetDemo(demofilter);
          setAssets(cloneDeep(demofilter.slice(0, countPerPage)));
        }
      } else if (value === null) {
        console.log("cleared");
        setAssetDemo(demofilter);
        setAssets(cloneDeep(demofilter.slice(0, countPerPage)));
      } else {
        console.log(demofilter);
        var filterAssets1 = demofilter.filter((item) => {
          return (
            moment(item.warranty).format("DD/MM/YYYY") ===
            moment(value).format("DD/MM/YYYY")
          );
        });
        const sort = filterAssets1.sort(
          (a, b) => b.fittingNumber - a.fittingNumber
        );
        setAssetDemo(sort);
        setAssets(cloneDeep(sort.slice(0, countPerPage)));
      }
    } catch (error) {
      console.error(error);
    }
  };

  //-----------------------------------------Display------------------------------------------
  const renderList = (
    <>
      {" "}
      <Row>
        <Col md="12" className="project-list">
          {data.sites !== "allSites" && (
            <Card className="custom-card">
              <Row>
                <Col md="6">
                  <H2>Logbook Report</H2>
                </Col>
                {assets.length > 0 &&
                  userPermission.includes("Download Reports") && (
                    <Col md="6" className="text-end">
                      <Btn attrBtn={{ color: "primary", onClick: generatePDF }}>
                        Download PDF
                      </Btn>
                    </Col>
                  )}
              </Row>
              <Row>
                <H4>Filters</H4>
                <Col md="4">
                  <Select
                    value={assetVal}
                    onChange={filterAssets}
                    options={asset}
                    isSearchable={true}
                    hideSelectedOptions={false}
                    placeholder="Choose Asset"
                    isClearable={true}
                    menuPlacement="auto"
                    menuPosition="fixed"
                  />
                </Col>
                <Col md="4">
                  <DatePicker
                    className="form-control"
                    selectsRange={false}
                    selected={warrantyDate}
                    onChange={(d) => {
                      console.log(d);
                      setWarrantyDate(d);
                      filterWarrantyDate(d);
                    }}
                    isClearable={true}
                    placeholderText="Warranty Upto"
                    dateFormat="dd-MM-yyyy"
                  />
                </Col>
                <Col md="4">
                  <DatePicker
                    className="form-control"
                    selectsRange={true}
                    startDate={startDate}
                    endDate={endDate}
                    onChange={(d) => {
                      setDateRange(d);
                      const [newStartDate, newEndDate] = d;
                      filterDateRage(newStartDate, newEndDate);
                    }}
                    isClearable={true}
                    placeholderText="Choose Date Range"
                    dateFormat="dd-MM-yyyy"
                  />
                </Col>
              </Row>
              <Row>
                <div className="card-block row">
                  <Col sm="12" lg="12" xl="12">
                    <div className="table-responsive">
                      <Table className="table-striped  table-de">
                        <thead className="custom-table-head">
                          <tr>
                            <th>Fitting No.</th>
                            <th>Location</th>
                            <th>Distribution Board</th>
                            <th>Asset Warranty Upto</th>
                            <th>Custom Fields</th>
                            <th>Asset Status</th>
                          </tr>
                        </thead>
                        <tbody className="trhover">
                          {assets.map((item) => (
                            <tr key={item.id}>
                              <td>{item.asset}</td>
                              <td>{item.location}</td>
                              <td>{getDB(item.distributionBox)}</td>
                              <td>
                                {item.warranty
                                  ? moment(item.warranty).format("DD/MM/YYYY")
                                  : "-"}
                              </td>
                              <td className="custom-fields-cell">
                                {item.customFields}
                              </td>
                              <td>{item.status}</td>
                            </tr>
                          ))}
                          {assetDemo.length === 0 && (
                            <tr>
                              <td className="text-center" colSpan="12">
                                No Reports Found for the selected Site and
                                Distribution Board
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </Col>
                </div>
              </Row>
              <CardFooter className="row">
                <Pagination
                  className="p-t-10"
                  pageSize={countPerPage}
                  onChange={updatePage}
                  current={currentPage}
                  total={assetDemo.length}
                  showTotal={(total, range) =>
                    `${range[0]} - ${range[1]} of ${total} items`
                  }
                />
              </CardFooter>
            </Card>
          )}
        </Col>
      </Row>
    </>
  );
  return (
    <div>
      {loading ? <LoadingSpinner /> : renderList}
      {errorMessage && <div className="error">{errorMessage}</div>}
    </div>
  );
};
export default GenerateLogBookReports;
